var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 669.58 430.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#e0e0e0;}.cls-3{fill:#f5f5f5;}.cls-4{fill:#fff;}.cls-5{fill:#fafafa;}.cls-6{fill:#263238;}.cls-7{fill:#0092bc;}.cls-8{fill:#455a64;}.cls-9{fill:#0b0c0c;}.cls-10{fill:#eb996e;}.cls-11{fill:#b78876;}.cls-12{fill:#ffbe9d;}.cls-13,.cls-16{opacity:0.3;}.cls-14{fill:#aa6550;}.cls-15{opacity:0.4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M655.87,249.91s-7.92-.57-7.19,17.19,2.54,27.23,2.54,27.23-.23,3.94-3.28,3.16-8.79-4.6-11.62-1.74-1.9,7.53,2,12.9,12,17.44,12.74,18.54,1,3.09-1.16,2.9-16.76-5.15-18.69,1.92S642.6,352.25,644,353.72s1.51,2.39.93,3.28-5.33-1.24-9.54-2.47-9.3-1.94-10.08,2.23,5.1,16.38,27.06,29.2L663,391.24l10-6.38c20.57-15,25.19-27.69,24-31.76s-6.19-2.87-10.25-1.22-8.58,4.24-9.24,3.42-.68-1.76.59-3.36,13.21-16,10.58-22.88S672,328.6,669.86,329s-2.05-1.62-1.44-2.76,7.48-14,10.82-19.72,3.92-10.38.7-13-8.43,1.82-11.39,2.9-3.58-2.83-3.58-2.83.85-9.59-.2-27.34-9.06-16.31-9.06-16.31",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.5,265.82s0,.12,0,.37.05.62.08,1.09c.07,1,.17,2.39.29,4.19.24,3.65.55,8.92.91,15.44.73,13,1.57,31,2.44,51s1.67,37.92,2.33,51c.33,6.51.59,11.78.78,15.44.09,1.81.16,3.22.21,4.2,0,.47,0,.83,0,1.1a3.49,3.49,0,0,1,0,.37s0-.13,0-.37-.05-.63-.08-1.09c-.07-1-.16-2.39-.29-4.2-.24-3.64-.55-8.91-.91-15.43-.73-13-1.57-31.06-2.44-51s-1.67-37.92-2.32-51c-.33-6.5-.6-11.77-.79-15.44-.09-1.81-.16-3.22-.21-4.2,0-.46,0-.83,0-1.09A3.39,3.39,0,0,1,656.5,265.82Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M644.13,301.44a3.4,3.4,0,0,1,.66.54c.4.37,1,.93,1.67,1.61,1.4,1.39,3.27,3.35,5.3,5.55l5.17,5.65,1.57,1.71a3.11,3.11,0,0,1,.55.65,3.81,3.81,0,0,1-.66-.54c-.4-.37-1-.92-1.67-1.62-1.38-1.4-3.23-3.38-5.26-5.58l-5.2-5.62-1.59-1.69A3.4,3.4,0,0,1,644.13,301.44Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.1,316.8c-.08-.08,3.79-4.12,8.64-9s8.84-8.83,8.92-8.75-3.79,4.12-8.64,9S660.18,316.88,660.1,316.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.06,347.43a4.07,4.07,0,0,1,.74-.47l2.06-1.16c1.75-1,4.15-2.34,6.75-3.94s4.91-3.11,6.58-4.22l2-1.32a3,3,0,0,1,.75-.44,3.82,3.82,0,0,1-.66.57c-.44.34-1.09.83-1.9,1.42-1.63,1.18-3.91,2.74-6.53,4.34s-5,2.93-6.82,3.84c-.89.46-1.62.82-2.13,1.05A3.2,3.2,0,0,1,660.06,347.43Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.55,336.71a3.43,3.43,0,0,1,.73.35c.46.24,1.11.6,1.92,1.06,1.61.91,3.82,2.2,6.24,3.64s4.61,2.77,6.19,3.75l1.85,1.18a3.53,3.53,0,0,1,.65.47,2.34,2.34,0,0,1-.73-.34c-.46-.24-1.12-.61-1.92-1.06-1.61-.92-3.82-2.2-6.25-3.65s-4.61-2.77-6.18-3.74c-.78-.49-1.42-.89-1.85-1.18A2.84,2.84,0,0,1,642.55,336.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M639.08,363.75a4.35,4.35,0,0,1,.93.45l2.46,1.35c2.06,1.16,4.91,2.79,8,4.61s5.94,3.49,8,4.71l2.39,1.47a4.61,4.61,0,0,1,.85.59,6.15,6.15,0,0,1-.93-.45l-2.46-1.36c-2.07-1.16-4.91-2.79-8-4.61s-5.95-3.49-8-4.71l-2.39-1.47A5,5,0,0,1,639.08,363.75Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M661.28,376.46a5.85,5.85,0,0,1,.92-.62l2.57-1.56c2.16-1.32,5.15-3.16,8.4-5.27s6.13-4.1,8.22-5.55l2.47-1.72a5.74,5.74,0,0,1,.93-.59,5.35,5.35,0,0,1-.84.72c-.56.44-1.37,1.07-2.4,1.82-2,1.51-4.91,3.54-8.16,5.66s-6.27,3.92-8.48,5.18c-1.1.62-2,1.12-2.63,1.45A6.69,6.69,0,0,1,661.28,376.46Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "641.81 342.56 612.57 342.56 622.11 414.8 632.27 414.8 641.81 342.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M649.44,403.58s0,.1.16.26a1.82,1.82,0,0,0,.7.5,3.54,3.54,0,0,0,3.09-.38c1.18-.65,2.21-1.93,3.79-2.49a8.36,8.36,0,0,1,5.38.1,23.54,23.54,0,0,1,5,2.43,34,34,0,0,0,4.07,2.18,11.09,11.09,0,0,0,3,.87,5,5,0,0,0,.85.06.94.94,0,0,0,.29,0,16,16,0,0,1-4-1.21,40,40,0,0,1-4-2.26,22.35,22.35,0,0,0-5.09-2.5,8.56,8.56,0,0,0-5.67-.06,7.32,7.32,0,0,0-2.14,1.32,16.48,16.48,0,0,1-1.67,1.29,3.44,3.44,0,0,1-2.85.5A3,3,0,0,1,649.44,403.58Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M650.51,416.89s.23-.3.69-.78a6.45,6.45,0,0,1,2.33-1.48,10.45,10.45,0,0,1,4.07-.61,41.29,41.29,0,0,1,5.09.69,17.81,17.81,0,0,0,5.21.22,14.5,14.5,0,0,0,4.09-1.17,13.17,13.17,0,0,0,2.47-1.47,3.37,3.37,0,0,0,.78-.7,25.81,25.81,0,0,1-3.38,1.86,15.26,15.26,0,0,1-4,1,18.13,18.13,0,0,1-5.08-.25,38.25,38.25,0,0,0-5.15-.66,10.19,10.19,0,0,0-4.2.74,6.17,6.17,0,0,0-2.35,1.67,4.38,4.38,0,0,0-.44.64C650.53,416.79,650.49,416.88,650.51,416.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M673.85,424a2.42,2.42,0,0,0-.81-.42,8.25,8.25,0,0,0-2.42-.52,15.34,15.34,0,0,0-3.66.21c-1.37.22-2.83.6-4.36.92a18.1,18.1,0,0,1-4.36.49,9.26,9.26,0,0,1-3.45-.74,8.09,8.09,0,0,1-2.63-1.95,2.55,2.55,0,0,0,.5.76,6.2,6.2,0,0,0,2,1.49,9.23,9.23,0,0,0,3.58.88,17.32,17.32,0,0,0,4.48-.46c1.55-.33,3-.72,4.33-1a16.92,16.92,0,0,1,3.57-.3A13.81,13.81,0,0,1,673.85,424Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M653.09,434a4.71,4.71,0,0,1,2.84-.29,14,14,0,0,1,3,1.11,11.36,11.36,0,0,0,3.86,1.06,11.53,11.53,0,0,0,7-1.62,10.31,10.31,0,0,0,1.74-1.34,2.82,2.82,0,0,0,.52-.62,26.71,26.71,0,0,1-2.43,1.67,12.06,12.06,0,0,1-6.78,1.44c-2.77-.16-4.9-1.81-6.81-2a4.33,4.33,0,0,0-2.21.19A1.46,1.46,0,0,0,653.09,434Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M654.72,447.89a5.52,5.52,0,0,0,2.44-.48c1.47-.49,3.29-1.62,5.41-2.46a8.67,8.67,0,0,1,3.11-.65,5.66,5.66,0,0,1,2.5.57,5.5,5.5,0,0,1,1.8,1.55,1.45,1.45,0,0,0-.27-.61,4,4,0,0,0-1.37-1.24,5.78,5.78,0,0,0-2.65-.71,8.77,8.77,0,0,0-3.29.64c-2.2.88-4,2-5.37,2.6S654.71,447.82,654.72,447.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M656.15,454.34A6.82,6.82,0,0,0,658,455a33.65,33.65,0,0,0,4.63.78,34.22,34.22,0,0,0,4.69.13,7.16,7.16,0,0,0,1.94-.23c0-.14-3,0-6.58-.38S656.19,454.2,656.15,454.34Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "451.49 0.65 451.49 59.47 367.01 59.47 363.97 1.06 451.49 0.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 412.42,
    y: 40.11,
    width: 58.28,
    height: 84.48,
    transform: "translate(323.86 471.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M484.2,111.89H398.92V52.81H484.2Zm-84.48-.8H483.4V53.61H399.72Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 373.12,
    y: 8.3,
    width: 66.18,
    height: 43.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M474.65,60.45h-1.27l-3.63,0-13.64.06-47.64.09.19-.19c0,13.38,0,28.21,0,43.79h0l-.21-.21,66.18,0-.16.17c0-13.33.06-24.26.08-31.87,0-3.8,0-6.78.05-8.81,0-1,0-1.78,0-2.32s0-.8,0-.8,0,.25,0,.77,0,1.29,0,2.28c0,2,0,5,0,8.78,0,7.63,0,18.6.09,32v.16h-.17l-66.18,0h-.21v-.21h0c0-15.58,0-30.41,0-43.79v-.19h.19l47.77.09,13.59,0,3.6,0h1.22Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.32,53a7.57,7.57,0,0,1,1.46.94c.86.63,2,1.51,3.31,2.53s2.39,2,3.17,2.7a6.64,6.64,0,0,1,1.21,1.24c-.08.09-2.11-1.59-4.64-3.61A46.83,46.83,0,0,1,399.32,53Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483.8,53.21A41.91,41.91,0,0,1,479.36,57a41.48,41.48,0,0,1-4.71,3.46,40.83,40.83,0,0,1,4.45-3.79A40,40,0,0,1,483.8,53.21Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M483.73,111.5l-9.41-7.64",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M474.32,103.86a44.54,44.54,0,0,1,4.84,3.66,42.89,42.89,0,0,1,4.57,4,45.7,45.7,0,0,1-4.84-3.66A41.6,41.6,0,0,1,474.32,103.86Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.32,111.49a40.49,40.49,0,0,1,4.4-3.75,40.61,40.61,0,0,1,4.66-3.41,41.14,41.14,0,0,1-4.4,3.74A40,40,0,0,1,399.32,111.49Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 435.4,
    y: 60.61,
    width: 14.67,
    height: 41.64,
    transform: "translate(325.95 472.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 488.37,
    y: 17.45,
    width: 76.07,
    height: 125.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 485.84,
    y: 17.45,
    width: 76.07,
    height: 125.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 489.08,
    y: 20,
    width: 69.59,
    height: 120.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 502.33,
    y: 35.7,
    width: 42.79,
    height: 89.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.68,145.62c-.1-8.35,7.41-16.51,15.68-17.67,3.95-.56,8.14.22,11.82-1.29,6.58-2.7,8.67-11.44,15.29-14l.3,64.63H537.68Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "360.83 140.76 417.19 171.97 415.07 175.94 359.22 144.15 360.83 140.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "358.06 137.81 360.65 133.84 362.16 134.77 359.84 138.78 358.06 137.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "410.79 167.03 413.69 168.7 404.25 228.92 399.78 228.97 410.79 167.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.15,287.33s6.87-6.95,16.07-6.44a20,20,0,0,1,13.93,6.41Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.47,217.25l-22.32-12.88,6.44-11.16a12.88,12.88,0,0,1,17.6-4.71h0a12.88,12.88,0,0,1,4.72,17.6Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.7,
    y: 280.9,
    width: 71.5,
    height: 3.48,
    transform: "translate(423.54 513.14) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "240.93 232.24 254.34 181.98 198.51 181.98 186.36 232.24 240.93 232.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "189.71 228.43 239.58 228.43 251.19 184.3 201.06 184.3 189.71 228.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 144.18,
    y: 242.53,
    width: 3.61,
    height: 172.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.79,
    y: 243.03,
    width: 3.61,
    height: 171.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 366.64,
    y: 242.53,
    width: 3.61,
    height: 172.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 370.25,
    y: 243.03,
    width: 3.61,
    height: 171.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.59,
    y: 232.52,
    width: 274.28,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 247.7,
    y: 246.66,
    width: 120.75,
    height: 23.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.81,308.89a2.69,2.69,0,1,1-2.69-2.69A2.7,2.7,0,0,1,348.81,308.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.48,368.75h47.43a6,6,0,0,0,6-6V348.1a10.19,10.19,0,0,0-10.18-10.19H144.12Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.11,377.94H97.86a4.6,4.6,0,0,1-4.6-4.59h0a4.6,4.6,0,0,1,4.6-4.6h93.25a4.6,4.6,0,0,1,4.6,4.6h0A4.6,4.6,0,0,1,191.11,377.94Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.85,246.31l51.31-.91,32.56,123.08-69.46.7L67.08,261.28A12.12,12.12,0,0,1,78.85,246.31Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.05 325.8 53.7 415.01 57.91 415.01 78.09 325.8 69.05 325.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.24 325.8 88.93 415.01 93.14 415.01 114.28 325.8 105.24 325.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.27 325.8 163.47 415.01 159.26 415.01 136.23 325.8 145.27 325.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.28,245.4l25.39,123.21h19.47L148.78,259.74a17.52,17.52,0,0,0-17.24-14.34Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.73,
    y: 79.99,
    width: 2.62,
    height: 23.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.08,
    y: 79.99,
    width: 2.62,
    height: 23.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.06,
    y: 70.56,
    width: 109.81,
    height: 9.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.04,
    width: 15.14,
    height: 70.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.26,105.78a3,3,0,1,1-3-3A3,3,0,0,1,154.26,105.78Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 113.46,
    y: 18.69,
    width: 4.63,
    height: 28.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 92.66,
    width: 15.14,
    height: 70.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.88,105.78a3,3,0,1,1-3-3A3,3,0,0,1,138.88,105.78Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 98.09,
    y: 18.69,
    width: 4.63,
    height: 28.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.01,
    width: 15.14,
    height: 70.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.24,105.78a3,3,0,1,1-3-3A3,3,0,0,1,124.24,105.78Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 83.44,
    y: 18.69,
    width: 4.63,
    height: 28.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.29 69.48 77.48 7.41 71.21 4.66 52.55 67.24 59.29 69.48"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M704.93,466.94c0,.15-147.73.26-329.91.26s-329.95-.11-329.95-.26,147.69-.26,330-.26S704.93,466.8,704.93,466.94Z",
    transform: "translate(-35.35 -52.14)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M116.72,384.7c9.11,3.18,21,.34,28.79-5.35s13.39-13.84,18.36-22.11c2.12-3.53,4.19-7.21,4.86-11.27s-.31-8.63-3.46-11.28c-4.9-4.12-12.4-2-18,1.13a62,62,0,0,0-30.59,48.88",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126.5,406.5c5.47,7.22,14.87,10.43,23.92,10.85s18-2.08,26.43-5.33c3.07-1.17,6.43-2.79,7.48-5.9a7.48,7.48,0,0,0-1.6-7,15.59,15.59,0,0,0-6.11-4.16c-8.32-3.55-17.85-3.71-26.61-1.44s-16.4,7.34-23.51,12.94",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M116.59,345.68c7.54.15,13.25-6.45,16.66-13.18a48.79,48.79,0,0,0,4.49-30.45c-.69-3.86-2.14-8-5.59-9.86s-8.07-.65-11,2-4.55,6.5-5.72,10.3c-4.05,13.1-3.18,28.15,1.16,41.15",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.83,387.39c12.85-21.88,15-48.65,7.4-72.87-1.23-3.92-3.56-8.42-7.66-8.68-4.55-.29-7.41,4.78-8.66,9.17-4.41,15.37-3.47,31.7-2.5,47.67.6,9.83,4,18.24,11.42,24.71",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.46,396.38a52.6,52.6,0,0,0-31.2-33.08c-3.41-1.28-7.75-2-10.3.6s-1.73,6.84-.12,10c2.58,5.17,6.79,9.32,11,13.3,3.81,3.63,7.77,7.27,12.58,9.37s13.66,2.64,18.07-.23",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.16,340.18l-.23.2-.69.53-2.69,2c-.6.43-1.25.91-2,1.44s-1.43,1.17-2.24,1.82c-1.59,1.33-3.47,2.77-5.36,4.57-1,.87-2,1.79-3,2.75s-2.06,2.05-3.15,3.13c-2.22,2.13-4.36,4.61-6.66,7.17a141.44,141.44,0,0,0-23.5,38c-1.26,3.21-2.53,6.24-3.44,9.17-.48,1.46-1,2.85-1.39,4.22s-.76,2.68-1.11,3.94c-.76,2.5-1.2,4.82-1.68,6.84-.22,1-.46,1.94-.63,2.82s-.29,1.67-.42,2.39c-.25,1.4-.45,2.51-.59,3.31-.07.35-.13.63-.17.86a1.94,1.94,0,0,1-.08.29,1,1,0,0,1,0-.3c0-.23.07-.52.11-.87.12-.81.28-1.92.49-3.33.11-.73.23-1.53.37-2.41s.37-1.82.58-2.83c.45-2,.86-4.37,1.6-6.88l1.07-4c.38-1.37.9-2.77,1.36-4.24.9-2.95,2.15-6,3.4-9.22a153,153,0,0,1,10.24-20.05,151.06,151.06,0,0,1,13.35-18.11c2.33-2.57,4.49-5.05,6.73-7.17,1.1-1.07,2.12-2.15,3.19-3.11l3.06-2.74c1.92-1.78,3.82-3.19,5.44-4.5.82-.64,1.56-1.26,2.28-1.79l2-1.4,2.76-1.93.73-.49C158.06,340.22,158.15,340.17,158.16,340.18Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.18,400.82a5.18,5.18,0,0,1-.88-.14c-.58-.11-1.41-.33-2.5-.51a69.06,69.06,0,0,0-70.21,29.21c-.64.9-1.07,1.65-1.4,2.13a4.48,4.48,0,0,1-.52.73,5.59,5.59,0,0,1,.41-.79c.3-.5.7-1.27,1.32-2.2a63.2,63.2,0,0,1,5.62-7.56,66.89,66.89,0,0,1,55.5-23.09,62.54,62.54,0,0,1,9.32,1.34c1.09.22,1.92.48,2.49.62A4.72,4.72,0,0,1,175.18,400.82Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.7,300.92s0,.12,0,.34-.13.58-.21,1c-.2.91-.49,2.17-.84,3.77-.74,3.27-1.87,8-3.29,13.81-2.84,11.65-6.95,27.68-11.24,45.45-2.13,8.9-4.06,17.39-5.72,25.14s-3,14.74-4.06,20.64c-.55,2.95-1,5.62-1.36,8s-.72,4.37-1,6-.45,2.9-.6,3.81c-.07.41-.12.73-.17,1a1.52,1.52,0,0,1-.07.33,1.24,1.24,0,0,1,0-.34c0-.26.07-.59.11-1,.12-.91.28-2.2.48-3.83s.49-3.69.86-6,.75-5,1.28-8c1-5.92,2.33-12.93,3.93-20.69s3.55-16.26,5.68-25.16c4.29-17.78,8.47-33.8,11.41-45.42,1.46-5.77,2.64-10.46,3.48-13.76.4-1.59.72-2.84,1-3.73.11-.4.2-.72.26-1A2.42,2.42,0,0,1,127.7,300.92Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.19,428.42s0-.08-.09-.26-.1-.47-.18-.79c-.15-.75-.36-1.76-.63-3.05-.54-2.64-1.27-6.48-2.09-11.24-1.65-9.52-3.6-22.74-4.8-37.44-.59-7.36-.91-14.38-1.05-20.77s0-12.15.15-17c.06-2.42.22-4.6.32-6.52s.23-3.56.36-4.91.21-2.34.28-3.09c0-.33.07-.59.09-.81a1.45,1.45,0,0,1,0-.27.84.84,0,0,1,0,.28l0,.81c0,.76-.1,1.79-.18,3.1s-.18,3-.25,4.91-.2,4.1-.23,6.51c-.15,4.82-.16,10.57,0,16.95s.51,13.39,1.09,20.73c1.2,14.68,3.09,27.89,4.62,37.42.77,4.76,1.43,8.61,1.9,11.27.22,1.29.4,2.32.52,3.07,0,.32.09.58.12.8A.93.93,0,0,1,98.19,428.42Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.14,431.2a3.69,3.69,0,0,1-.34-.75c-.21-.56-.49-1.29-.84-2.2l-.61-1.59c-.25-.58-.53-1.19-.82-1.85s-.61-1.38-1-2.13-.76-1.51-1.17-2.33L93.1,417.8l-1.56-2.69c-1-1.88-2.37-3.76-3.66-5.8a136.33,136.33,0,0,0-9.68-12.37,153.5,153.5,0,0,0-11.11-11.13c-1.85-1.56-3.54-3.11-5.25-4.42l-2.43-1.94-2.31-1.7c-1.46-1.11-2.83-2-4-2.84s-2.24-1.52-3.12-2.05l-2-1.26a4,4,0,0,1-.68-.48,4.9,4.9,0,0,1,.74.37l2.05,1.17c.9.5,2,1.16,3.18,2s2.63,1.69,4.11,2.78l2.34,1.68L62.15,381c1.73,1.29,3.44,2.84,5.31,4.4a142.63,142.63,0,0,1,11.19,11.13A129.2,129.2,0,0,1,88.34,409C89.63,411.06,91,413,92,414.86l1.54,2.72,1.29,2.58c.39.83.81,1.6,1.13,2.36s.62,1.48.91,2.15l.78,1.88.56,1.62c.3.92.55,1.67.74,2.24A4.65,4.65,0,0,1,99.14,431.2Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.39,365.55a40.4,40.4,0,0,1-4.06.24,74,74,0,0,0-9.7,1.17,75.36,75.36,0,0,0-9.46,2.47c-2.38.78-3.83,1.35-3.87,1.27a3.59,3.59,0,0,1,1-.53c.63-.3,1.57-.7,2.75-1.15a58.16,58.16,0,0,1,19.29-3.66c1.26,0,2.29,0,3,.06A3.78,3.78,0,0,1,153.39,365.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.09,412.92c-.18.09-1.64-4.1-5.29-8s-7.68-5.7-7.57-5.87a9,9,0,0,1,2.61,1.15,23.41,23.41,0,0,1,5.4,4.3,23.06,23.06,0,0,1,3.89,5.71A9.29,9.29,0,0,1,163.09,412.92Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130,318.68c.12.13-2.25,2.48-4.83,5.66s-4.42,6-4.57,5.86a25.94,25.94,0,0,1,4.1-6.24A26.47,26.47,0,0,1,130,318.68Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.25,305.27c.17,0,.69,2.24,1.17,5.07a23.29,23.29,0,0,1,.58,5.18c-.17,0-.69-2.24-1.18-5.08A22.84,22.84,0,0,1,122.25,305.27Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.2,347.36c.15.08-1.53,3.62-3.76,7.92s-4.15,7.72-4.3,7.64,1.53-3.62,3.76-7.92S98.05,347.28,98.2,347.36Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.89,333.07a35.68,35.68,0,0,1,3.19,5.73c1.61,3.24,2.79,5.92,2.64,6a36.62,36.62,0,0,1-3.19-5.73C84.92,335.83,83.74,333.15,83.89,333.07Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M62.85,381.94c0,.18-2.59-.32-5.77-.54s-5.78-.1-5.8-.28a16.78,16.78,0,0,1,5.84-.32A16.64,16.64,0,0,1,62.85,381.94Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.22,425.15l7.15,37.64a5.29,5.29,0,0,0,5.19,4.29H110.7a5.27,5.27,0,0,0,5.2-4.42l6.23-37.51Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "44.19 385.24 84.62 385.24 86.77 373 41.87 373 44.19 385.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.19 385.24 45.04 389.7 84 389.7 84.62 385.24 44.19 385.24"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character_4",
    "data-name": "Character 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M555,152.2c.16,3.92.22,8.2-2.2,11.29-1.32,1.69-3.3,2.87-4.27,4.79-1.24,2.44-.53,5.41-1.16,8.08-.56,2.37-2.15,4.36-3.1,6.61a11.74,11.74,0,0,0,.56,10.49,9.71,9.71,0,0,0,9.18,4.7c3.06-.37,5.71-2.33,7.79-4.59a25.95,25.95,0,0,0-2.17-37.2",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M602.39,130.68a15.6,15.6,0,0,0,3.07,10.67c2.33,3,5.14,5.92,5.39,9.67.19,2.78-1.11,5.49-1,8.28.25,6.69,8.1,10.8,9.47,17.36a9.58,9.58,0,0,1-13.17,10.76c-4.78-2.06-7.11-7.71-7.1-12.91s1.81-10.21,3-15.27c2.2-9.06,1-16.9-.51-26.1",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M607.36,161.71c-1.34-2.27-2.91-4.66-2.72-7.3.22-3,2.73-5.69,2.12-8.63-.38-1.83-1.88-3.18-2.82-4.79-1.7-2.92-1.49-6.5-1.54-9.88s-.58-7.11-3.19-9.25-6-2-9-3c-1.55-.55-3-1.42-4.54-2-3.3-1.18-7.3-1.77-10.5-.35a16.94,16.94,0,0,0-6.1,4c-2.55,2-3.38,6.75-4,10-.78,3.92-1,8.08-3,11.52-1.24,2.11-3.06,3.79-4.61,5.68s-2.87,4.16-2.77,6.6c.12,2.78,2.08,5.36,1.66,8.11-.24,1.58-1.24,2.94-1.65,4.49-.75,2.86.69,6,2.88,7.94s5,3.1,7.8,4.12,5.63,2,7.95,3.88,4.32,4.8,7.32,5.62c2.57.7,5.27-.31,7.74-1.31,4.49-1.8,9.18-3.76,12.15-7.57,1.36-1.74,2.29-3.8,3.81-5.41s3.75-2.85,4.6-5C609.9,166.74,608.71,164,607.36,161.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M541.49,309.22c2.16.76,5.73-8.05,6.09-8.77s1.41-.24,1.06.4c-.52.91-5.69,10.65-3.58,11.41,1.17.42,1.73-1.75,1.73-1.75s4.16-9.46,5.15-9.07-1.26,6-2.16,7.89-.38,3,.76,2.7c.77-.19,3.65-5.78,4.49-7.62s3.07-7,4-3.55,3,5.67,3.94,5.9a1.11,1.11,0,0,0,.94-1.87,12.66,12.66,0,0,1-1.6-3.19,6.38,6.38,0,0,1-.55-2.81c0-.53.08-1,.12-1.46l0,0,.06-1.51c.11-1.83.11-2.82.11-2.82h0l2.91-75.4L548.5,199.34l-.41,91.52.06,0a102.24,102.24,0,0,0-6.39,8.56c-2.74,4.5-2.34,4.75-1.76,5,1.55.62,5.12-7.73,5.4-5.49S539.84,308.65,541.49,309.22Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M610.61,270.28c0-.14,0-.3,0-.38S610.63,270.08,610.61,270.28Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M610.57,270.63c0-.14,0-.25,0-.35Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M624.22,452.42S597,358.2,596.46,355.23c-.48-2.68,12.26-67.73,14.11-84.6l-38.68.36s0,.11,0,.29l-18.68.51L563,459.61l20.62.3-.88-63.21c10.15,29.74,23,63.33,23,63.33Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M610.66,269.85Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M610.65,269.9v0A.07.07,0,0,0,610.65,269.9Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M570.42,351.06a19.73,19.73,0,0,1-.12,2,41,41,0,0,0,.1,5.5,50.11,50.11,0,0,0,1.37,8,79.72,79.72,0,0,0,3.28,9.44c2.55,6.66,4.82,12.7,6.44,17.07.77,2.13,1.41,3.88,1.89,5.2a12.88,12.88,0,0,1,.61,1.94,15.89,15.89,0,0,1-.83-1.85c-.52-1.31-1.22-3-2.06-5.13-1.72-4.35-4.06-10.36-6.61-17-.63-1.66-1.25-3.29-1.84-4.86a44.44,44.44,0,0,1-1.41-4.66,48.06,48.06,0,0,1-1.26-8.14,34,34,0,0,1,.09-5.55c.07-.65.15-1.15.22-1.49A1.58,1.58,0,0,1,570.42,351.06Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M582.83,418.8c0-.56.35-20.65.35-20.65s-6.74-18.62-6.91-18S582.83,418.8,582.83,418.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M562.9,461.59v-2.21l20.73,0,.05,7.26-1.28.08c-5.69.34-29,1.31-32.77.17C545.39,465.59,562.9,461.59,562.9,461.59Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.21,466.48a7.15,7.15,0,0,1,2.62-4.41,7,7,0,0,1,4.82-1.52l0,5.77Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M554.35,463.85s-6.14,1.79-5.37,2.8,24.32.92,34.71,0l0-.47-27.48.35S555.55,463.9,554.35,463.85Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M584,466.14l-.35,0-1,.07-3.75.17c-3.17.13-7.55.25-12.38.27s-9.22-.05-12.39-.15l-3.75-.14-1-.06-.35,0a1.41,1.41,0,0,1,.36,0h1l3.75.06c3.17.06,7.54.1,12.38.08s9.21-.11,12.37-.19l3.75-.1,1,0Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M556.19,466.82a8.69,8.69,0,0,0-.71-1.79,9.13,9.13,0,0,0-1.28-1.43,2.76,2.76,0,0,1,1.49,1.3A2.79,2.79,0,0,1,556.19,466.82Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M562.26,463.71c-.06,0-.35-.32-.65-.79s-.5-.89-.44-.93.35.32.65.79S562.32,463.67,562.26,463.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M563.93,462.82c0,.05-.37-.17-.73-.49s-.61-.61-.56-.66.37.16.73.48S564,462.76,563.93,462.82Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,460.86a2.37,2.37,0,0,1-1.08.15,2.4,2.4,0,0,1-1.08-.11,2.46,2.46,0,0,1,1.08-.14A2.68,2.68,0,0,1,565,460.86Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565.34,459.49a2.14,2.14,0,0,1-1.2.35,2.07,2.07,0,0,1-1.25-.16,6.9,6.9,0,0,1,1.23-.08A5.83,5.83,0,0,1,565.34,459.49Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M561.56,461.91a3.9,3.9,0,0,1-1.33,0,8.27,8.27,0,0,1-1.41-.31,3.84,3.84,0,0,1-.81-.33.73.73,0,0,1-.33-.41.51.51,0,0,1,.2-.53,2.44,2.44,0,0,1,3,.7,2.26,2.26,0,0,1,.43.88.77.77,0,0,1,0,.36,3.85,3.85,0,0,0-.61-1.13,2.35,2.35,0,0,0-1.14-.73,2.07,2.07,0,0,0-1.58.11c-.21.16-.12.41.11.55a3.82,3.82,0,0,0,.75.31,9.21,9.21,0,0,0,1.37.35C561.05,461.87,561.56,461.87,561.56,461.91Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M561.21,462a1.34,1.34,0,0,1-.15-.92,2.13,2.13,0,0,1,.35-1,1.32,1.32,0,0,1,1.1-.68.53.53,0,0,1,.42.61,1.49,1.49,0,0,1-.23.59,3.58,3.58,0,0,1-.62.8c-.41.41-.74.57-.76.54s.27-.23.63-.66a4.34,4.34,0,0,0,.55-.79c.18-.28.31-.79,0-.85s-.67.3-.87.57a2.18,2.18,0,0,0-.37.86A5.7,5.7,0,0,0,561.21,462Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M583.54,460.5a14.23,14.23,0,0,0-1.53.06,6.43,6.43,0,0,0-5.38,4.33c-.31.88-.34,1.48-.39,1.47a1.51,1.51,0,0,1,0-.42,5.32,5.32,0,0,1,.22-1.11,6.36,6.36,0,0,1,2.08-3.08,6.28,6.28,0,0,1,3.46-1.37,5.52,5.52,0,0,1,1.13,0C583.4,460.44,583.54,460.48,583.54,460.5Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M573.61,464.48a17,17,0,0,1-6,.08c0-.07,1.35,0,3,0S573.6,464.41,573.61,464.48Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M577.65,464.46c.05.05-.11.28-.25.59s-.21.59-.28.58-.1-.32.06-.68S577.6,464.41,577.65,464.46Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M579.17,462.55c.05.05-.09.27-.3.48s-.42.36-.47.31.08-.26.29-.48S579.12,462.5,579.17,462.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M581.34,461.68c0,.07-.29.07-.59.17s-.52.27-.57.23.11-.33.49-.46S581.36,461.61,581.34,461.68Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M582.89,461.26c0,.07-.09.17-.26.24s-.33.07-.36,0,.1-.18.27-.24S582.87,461.2,582.89,461.26Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M606.44,462.13l-.94-2,18.73-8.87,3.15,6.54-1.12.62c-5,2.74-25.64,13.55-29.57,14.15C592.31,473.23,606.44,462.13,606.44,462.13Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M620.56,460.87a7.15,7.15,0,0,1,.48-5.1,7,7,0,0,1,3.71-3.43l2.49,5.2Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M599.66,467.83s-4.78,4.24-3.65,4.83,22.38-9.56,31.37-14.86l-.23-.4-24.7,12S600.77,467.36,599.66,467.83Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M627.44,457.25l-.3.18-.9.5-3.31,1.76c-2.81,1.47-6.72,3.44-11.08,5.53s-8.36,3.88-11.27,5.15l-3.45,1.47-.94.39-.34.12a1.79,1.79,0,0,1,.32-.17l.92-.42,3.42-1.55c2.89-1.31,6.87-3.13,11.23-5.22s8.28-4,11.11-5.46l3.35-1.69.91-.45A1.69,1.69,0,0,1,627.44,457.25Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M602.6,469.73a5.43,5.43,0,0,0-3.18-2.06,3.32,3.32,0,0,1,3.18,2.06Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M606.76,464.32c0,.06-.45-.14-.93-.43s-.83-.59-.79-.65.45.13.93.43S606.8,464.26,606.76,464.32Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M607.89,462.8c0,.07-.41,0-.87-.12s-.81-.3-.79-.37.41,0,.86.13S607.91,462.74,607.89,462.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M608,460.59c0,.06-.38.33-.91.59a2.45,2.45,0,0,1-1,.36c0-.06.38-.32.91-.59A2.45,2.45,0,0,1,608,460.59Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M607.74,459.19c0,.05-.33.49-.93.84a2,2,0,0,1-1.2.38,6.35,6.35,0,0,1,1.07-.6A7,7,0,0,1,607.74,459.19Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605.35,463a3.66,3.66,0,0,1-1.2.56,8.28,8.28,0,0,1-1.4.33,4.16,4.16,0,0,1-.88,0,.7.7,0,0,1-.47-.23.5.5,0,0,1,0-.56,2.43,2.43,0,0,1,3-.65,2.26,2.26,0,0,1,.77.61c.15.18.2.3.19.31a3.63,3.63,0,0,0-1-.76,2.4,2.4,0,0,0-1.34-.18,2.07,2.07,0,0,0-1.38.78c-.12.23.06.42.33.44a4.42,4.42,0,0,0,.81,0,8.88,8.88,0,0,0,1.38-.27C604.88,463.18,605.34,463,605.35,463Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605.07,463.2a1.31,1.31,0,0,1-.53-.76,2.13,2.13,0,0,1-.09-1,1.33,1.33,0,0,1,.7-1.09.55.55,0,0,1,.64.38,1.54,1.54,0,0,1,.05.63,4.24,4.24,0,0,1-.22,1,1.89,1.89,0,0,1-.46.81s.14-.33.29-.87a4.79,4.79,0,0,0,.16-1c0-.33-.06-.83-.39-.75s-.48.56-.55.89a2.22,2.22,0,0,0,0,.94A4.88,4.88,0,0,0,605.07,463.2Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M624.63,452.33c0,.05-.56.21-1.35.71a6.49,6.49,0,0,0-3,6.21c.1.94.33,1.49.28,1.5a1.3,1.3,0,0,1-.18-.37,5.79,5.79,0,0,1-.27-1.11,6.25,6.25,0,0,1,3.11-6.38,5.31,5.31,0,0,1,1-.47A1.34,1.34,0,0,1,624.63,452.33Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M617.35,460.17a11.32,11.32,0,0,1-2.59,1.57,11.77,11.77,0,0,1-2.83,1.08c0-.07,1.23-.57,2.72-1.3S617.31,460.11,617.35,460.17Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M621,458.43c.07,0,0,.3,0,.64s.06.62,0,.65-.24-.25-.24-.64S620.93,458.4,621,458.43Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M621.55,456.06c.07,0,0,.27-.06.56s-.23.5-.3.48,0-.27.07-.56S621.49,456,621.55,456.06Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M623.15,454.34c0,.07-.23.18-.46.41s-.36.47-.42.45,0-.35.25-.63S623.14,454.27,623.15,454.34Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M624.37,453.3c0,.05,0,.19-.13.33s-.27.2-.32.15,0-.19.13-.32S624.32,453.25,624.37,453.3Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M622.3,206.57s-1.18-2.7-3.29-19.74c-.92-7.42-6-12-11.37-14.84v-.1l-.47-.13A44.45,44.45,0,0,0,593,167.64l-19.13-.31s-13.26-1-22.93,8c-3.18,2.94-6.42,29.26-6.42,29.26l9.56,3.4-.08-3.88s-.39,7.88,2.21,12.47l6.16,10.84L558.3,246.5c-2.54,7.29-10.87,33.91-7.6,60.29,4,32.66,4.7,42.21,4.7,42.21l46.19,6.32s18.46-69.16,12.13-96.64c-4.34-18.87-7.66-18-8.72-22.08l1.2-29.4Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M600.55,305.57c.37.61-4,4-9.88,7.46s-10.86,5.85-11.23,5.23,4-3.95,9.89-7.46S600.18,305,600.55,305.57Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M604.58,309c.33.64-1.57,2.29-4.08,4s-4.75,2.81-5.22,2.25,1.13-2.65,3.78-4.41S604.26,308.38,604.58,309Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M577.29,313c.37.61-.71,1.93-2.41,2.94s-3.37,1.32-3.73.7.71-1.94,2.41-2.94S576.93,312.33,577.29,313Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M579.85,283.89c.35.63-4.52,4-10.87,7.53s-11.79,5.89-12.13,5.26,4.51-4,10.86-7.53S579.5,283.26,579.85,283.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M580.07,278.88c.33.64-1.08,2-3.16,3.1s-4,1.42-4.35.78,1.09-2,3.16-3.09S579.74,278.25,580.07,278.88Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M562,299.94c.37.62-1.22,2.24-3.55,3.62s-4.51,2-4.87,1.39,1.22-2.24,3.54-3.63S561.65,299.32,562,299.94Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M613.07,259c.38.6-3.47,3.7-8.83,6.51s-10.09,4.23-10.37,3.58,3.91-3.11,9.16-5.88S612.69,258.42,613.07,259Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M609.17,252.38c.5.5-.24,2-1.87,3.12s-3.32,1.18-3.6.52.75-1.75,2.16-2.69S608.66,251.86,609.17,252.38Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M575.9,253.26c.4.6-2.54,3.26-6.58,5.95s-7.63,4.38-8,3.78,2.55-3.26,6.59-5.95S575.51,252.66,575.9,253.26Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M592.18,219.52c.36.62-3.34,3.43-8.27,6.28s-9.22,4.65-9.58,4,3.34-3.44,8.27-6.28S591.82,218.9,592.18,219.52Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M593.46,213.46c.22.69-1.64,1.9-4,3s-4.49,1.83-4.89,1.23,1.2-2.36,3.76-3.58S593.25,212.78,593.46,213.46Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M581.68,201.51c.33.64-4,3.51-9.69,6.43s-10.55,4.75-10.88,4.11,4-3.52,9.7-6.43S581.36,200.87,581.68,201.51Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583,195.21c.33.64-1.39,2.19-3.84,3.45s-4.7,1.77-5,1.13,1.39-2.18,3.84-3.45S582.65,194.58,583,195.21Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M614,182.14c.45.54-2.69,3.87-7.4,6.88s-9,4.49-9.35,3.85,3.38-3.11,7.94-6S613.58,181.57,614,182.14Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M570.65,181.47c.36.62-4.85,4.35-11.64,8.33s-12.59,6.72-13,6.09,4.84-4.35,11.64-8.33S570.28,180.85,570.65,181.47Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M567.19,179.06c.33.64-.83,1.89-2.58,2.8s-3.45,1.12-3.78.49.83-1.9,2.58-2.8S566.86,178.42,567.19,179.06Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M602.69,194.66c.24.69-1.11,1.77-2.79,2.83s-3.27,1.78-3.78,1.26.43-2.24,2.4-3.47S602.47,194,602.69,194.66Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M603.32,170.88c.39.6-.81,2.06-2.68,3.26s-3.69,1.68-4.08,1.07.81-2.07,2.68-3.26S602.93,170.27,603.32,170.88Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M586.47,261.53c.35.63-.61,1.83-2.14,2.68s-3.06,1-3.41.39.61-1.82,2.15-2.67S586.12,260.9,586.47,261.53Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M607.74,282.07c.38.6-3.58,3.78-9.14,6.56s-10.48,4.05-10.73,3.39,4.14-3,9.56-5.72S607.35,281.45,607.74,282.07Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M589.11,295.14c.35.64-.71,1.87-2.37,2.77s-3.26,1.1-3.6.47.71-1.87,2.37-2.76S588.77,294.51,589.11,295.14Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.9,331.69c.34.63-5.25,4.3-12.49,8.19s-13.38,6.54-13.72,5.91,5.25-4.31,12.49-8.2S583.56,331.06,583.9,331.69Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M582.16,327.19c.3.66-1.24,2-3.45,3s-4.25,1.33-4.55.67,1.24-2,3.45-3S581.86,326.54,582.16,327.19Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M602.54,341.5c.28.67-1.76,2.17-4.45,3.57s-5.09,2.22-5.48,1.61,1.48-2.46,4.27-3.91S602.26,340.84,602.54,341.5Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M573.29,170.3c.51-5.31.94-10.91.94-10.91s-6.72-1.81-7.26-10.87c-.52-8.64,1.85-21.93,1.85-21.93l.25-1.92c10.64-5.74,22.36-3.53,28.6,5h0l-4.82,43.06c-.56,5-5.31,8.5-10.65,7.86h0C576.79,180,572.81,175.36,573.29,170.3Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M569.08,135.76a1.14,1.14,0,0,0,1,1.26,1.1,1.1,0,0,0,1.28-.91,1.15,1.15,0,0,0-1-1.27A1.1,1.1,0,0,0,569.08,135.76Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M569.08,134.5c.13.16,1.06-.39,2.29-.27s2.07.83,2.22.69,0-.34-.41-.67a3.23,3.23,0,0,0-1.76-.74,3.05,3.05,0,0,0-1.84.4C569.17,134.17,569,134.43,569.08,134.5Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M581.88,137.42a1.15,1.15,0,0,0,1,1.26,1.09,1.09,0,0,0,1.28-.91,1.16,1.16,0,0,0-1-1.27A1.11,1.11,0,0,0,581.88,137.42Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M581.89,136.21c.12.16,1.06-.39,2.29-.27s2.07.83,2.22.69,0-.34-.41-.67a3.19,3.19,0,0,0-1.76-.73,3,3,0,0,0-1.84.4C582,135.88,581.82,136.14,581.89,136.21Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M576.52,144.9a8.43,8.43,0,0,0-2-.55c-.31-.07-.6-.16-.63-.38a1.61,1.61,0,0,1,.3-.91l1.17-2.3a42.88,42.88,0,0,0,2.7-6.06,40.78,40.78,0,0,0-3.18,5.82c-.4.81-.77,1.59-1.13,2.33a1.8,1.8,0,0,0-.29,1.21.78.78,0,0,0,.47.51,1.77,1.77,0,0,0,.53.13A8,8,0,0,0,576.52,144.9Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M574.23,159.39a22.81,22.81,0,0,0,12.27-2s-3.5,5.84-12.35,4.13Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M576.75,147.92a2.26,2.26,0,0,1,2.07-.63,2,2,0,0,1,1.32.89,1.31,1.31,0,0,1,0,1.48,1.52,1.52,0,0,1-1.66.25,4.65,4.65,0,0,1-1.48-1.1,1.48,1.48,0,0,1-.32-.39.44.44,0,0,1,.05-.46",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580.06,146.11c-.2,0-.33,1.31-1.57,2.14s-2.65.55-2.68.74.3.29.9.36a3.33,3.33,0,0,0,2.22-.53,2.91,2.91,0,0,0,1.23-1.81C580.27,146.46,580.15,146.11,580.06,146.11Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M573.42,132.88c-.07.2-.95,0-2,0s-1.93.15-2,0,.8-.7,2-.69S573.5,132.71,573.42,132.88Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M586.16,133.43s0-.1,0-.22l0,.19a8.66,8.66,0,0,0-2-.49c-1.19-.13-2.14.27-2.24.08s.14-.3.55-.51a3.39,3.39,0,0,1,1.76-.29,2.91,2.91,0,0,1,2.07,1l.09.14,0,0C586.27,133.43,586.2,133.46,586.16,133.43Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M586.48,141.67c-.1,0-.19-.12-.22-.31s0-.33.15-.35.19.13.21.31S586.58,141.66,586.48,141.67Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M583.58,141.55c-.1,0-.17-.17-.09-.35s.24-.24.31-.17a.27.27,0,0,1,0,.31A.3.3,0,0,1,583.58,141.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M585.15,142.8a.23.23,0,1,1,.2-.21C585.34,142.71,585.25,142.81,585.15,142.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M568.59,141c-.09,0-.16-.17-.14-.35s.13-.32.23-.31.16.17.14.35S568.69,141,568.59,141Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M571.52,141c-.1,0-.18-.13-.17-.28s.1-.26.2-.26.17.13.16.28S571.62,141,571.52,141Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M570.09,142c-.1,0-.18-.14-.18-.32s.07-.33.18-.33.18.14.18.32S570.19,142,570.09,142Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M566.24,137.65a5.91,5.91,0,0,1,4.42-6.37c2.75-.61,5.84.82,8.33-.5,2-1,2.88-3.52,4.88-4.49,1.66-.81,3.62-.39,5.47-.34s4-.62,4.52-2.41c-4-2.66-8.41-4.9-13.18-5.29s-9.93,1.36-12.63,5.31-2.52,8.88-2.3,13.54",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M588,124.79c-.42,2.44-.41,5.14,1.07,7.12a13.1,13.1,0,0,1,1.91,2.68c.84,2.06-.27,4.39-.13,6.62a6,6,0,0,0,2.16,4.17,3,3,0,0,0,3.32.56,3.73,3.73,0,0,0,1.33-2.41,53.47,53.47,0,0,0,1.54-10.45,5.85,5.85,0,0,0-3.3-6.45,39,39,0,0,0-3.77-2.15,5,5,0,0,0-2.52-.7,1.84,1.84,0,0,0-1.77,1.64",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M593.45,148.17a2.06,2.06,0,0,0,1.93.39,4.26,4.26,0,0,0,1.74-1,6.49,6.49,0,0,0,1.69-2.27,3.77,3.77,0,0,0,.1-2.78,3.6,3.6,0,0,0-2-1.95,5.11,5.11,0,0,0-2.79-.31Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M594.4,146.37c-.1,0,.26.61,1.07.42a1.79,1.79,0,0,0,1-.88,4.4,4.4,0,0,0,.51-1.52,2.55,2.55,0,0,0-.29-1.65,1.54,1.54,0,0,0-1.12-.78c-.83-.05-1.11.54-1,.56s.4-.22.93-.06a1.58,1.58,0,0,1,.83,1.84c-.14.95-.53,1.81-1,2S594.46,146.3,594.4,146.37Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M612.42,171.8a5,5,0,0,1,.54-.07,2.52,2.52,0,0,0,1.32-.68,4,4,0,0,0,1.13-2.08,4.28,4.28,0,0,0-.52-3.05,12.39,12.39,0,0,0-2.46-3,20.63,20.63,0,0,1-3.1-3.41,6.57,6.57,0,0,1-1-2.36,5.38,5.38,0,0,1,.24-2.66c.58-1.72,1.73-3.18,2.43-4.85a6.17,6.17,0,0,0-.07-5,12.76,12.76,0,0,0-2.85-4c-1.14-1.11-2.32-2.09-3.36-3.08a16.84,16.84,0,0,1-2.62-3,7.89,7.89,0,0,1-1.22-5.6,4.76,4.76,0,0,1,.57-1.47,2.25,2.25,0,0,1,.33-.44,7.25,7.25,0,0,0-.7,2,7.83,7.83,0,0,0,1.33,5.36,16.18,16.18,0,0,0,2.61,2.93c1,1,2.23,1.92,3.39,3.05a13,13,0,0,1,3,4.14,7.26,7.26,0,0,1,.63,2.67,6.52,6.52,0,0,1-.55,2.78c-.74,1.76-1.89,3.2-2.42,4.81a5,5,0,0,0,.64,4.6,19.86,19.86,0,0,0,3,3.36,12.82,12.82,0,0,1,2.49,3.15,5.51,5.51,0,0,1,.56,1.69,4.16,4.16,0,0,1-.09,1.59,4.11,4.11,0,0,1-1.27,2.17,2.51,2.51,0,0,1-1.45.64A1.64,1.64,0,0,1,612.42,171.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M621.14,206.57c-.56,8.73-.09,13.71-2.87,27.21-5.17,25-61.93,14.94-61.93,14.94h0c-4.39.15-7.41-.17-10.29.08-3.54.31-5,.19-5-.47,0-.89-.06-.55,6.3-2,0,0-9.09,2-7.47,0,.72-.88,8.26-2.65,8.26-2.65-5.93,2-8.47,1.78-8.72.87-.36-1.32,8.8-3.39,8.8-3.39s-7,1.72-8.27,1.64-.23-1.24.94-1.95,9.6-4.3,11.93-5.43a1.53,1.53,0,0,0,.85-2.17c-2.25-3-2.38-6.59-2-7.57a1.15,1.15,0,0,1,2.16.41,14,14,0,0,0,1.66,3.44,9.36,9.36,0,0,0,2,2.3c.92.74,1.73,1.34,2.43,1.83,5.85.55,22.47,1.76,36.37-3.5,5.11-1.93,5.5-23.4,5.5-23.4Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M551.16,245.5c.05.16-1.89.69-4.31,1.19a17.31,17.31,0,0,1-4.43.62c0-.17,1.9-.7,4.31-1.2A17.4,17.4,0,0,1,551.16,245.5Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M550.85,243c0,.16-2,.84-4.52,1.53a19.14,19.14,0,0,1-4.68,1,18.93,18.93,0,0,1,4.53-1.53A19.19,19.19,0,0,1,550.85,243Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M550.52,240.41a18.28,18.28,0,0,1-4.26,1.52,17.84,17.84,0,0,1-4.42.95,17.27,17.27,0,0,1,4.26-1.52A16.81,16.81,0,0,1,550.52,240.41Z",
    transform: "translate(-35.35 -52.14)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character_3",
    "data-name": "Character 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M427.81,163l19.94-1.6c.13-2.32,0-11.33,0-11.33s8.3-1.29,8.4-9.59-1.34-27.35-1.34-27.35h0a28.84,28.84,0,0,0-29,3.65l-1.23.94Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M447.72,149.93a19.32,19.32,0,0,1-10.81-3.08s2.55,6,10.83,5.23Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M425.59,126.3c-.14-.07-5.7-1.69-5.52,4s5.84,4.32,5.85,4.16S425.59,126.3,425.59,126.3Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M424.12,132.34s-.1.08-.27.16a1,1,0,0,1-.73,0,2.45,2.45,0,0,1-1.21-2.16,3.24,3.24,0,0,1,.24-1.42,1.17,1.17,0,0,1,.72-.79.52.52,0,0,1,.59.26c.08.15.05.27.08.28s.11-.1.06-.34a.65.65,0,0,0-.23-.34.73.73,0,0,0-.55-.13,1.39,1.39,0,0,0-1,.91,3.42,3.42,0,0,0-.29,1.59,2.56,2.56,0,0,0,1.52,2.41,1.07,1.07,0,0,0,.9-.18C424.11,132.48,424.14,132.35,424.12,132.34Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M452.94,126.12a1.17,1.17,0,0,1-1.14,1.19,1.13,1.13,0,0,1-1.22-1.07,1.18,1.18,0,0,1,1.14-1.19A1.13,1.13,0,0,1,452.94,126.12Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M453.2,124.78c-.14.16-1-.51-2.32-.5s-2.21.64-2.34.48.08-.35.49-.64a3.22,3.22,0,0,1,1.87-.58,3.14,3.14,0,0,1,1.85.59C453.14,124.44,453.28,124.72,453.2,124.78Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440.46,126.42a1.18,1.18,0,0,1-1.14,1.19,1.14,1.14,0,0,1-1.23-1.07,1.18,1.18,0,0,1,1.15-1.19A1.13,1.13,0,0,1,440.46,126.42Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440.67,125c-.15.16-1.05-.51-2.32-.5s-2.21.64-2.35.48.08-.35.49-.64a3.18,3.18,0,0,1,1.88-.58,3.1,3.1,0,0,1,1.85.59C440.61,124.67,440.74,125,440.67,125Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445.3,134.48a8,8,0,0,1,2.07-.38c.32,0,.63-.09.69-.32a1.69,1.69,0,0,0-.22-1c-.31-.79-.63-1.62-1-2.48a42.81,42.81,0,0,1-2.17-6.49,41.21,41.21,0,0,1,2.68,6.3c.33.87.63,1.7.93,2.49a1.89,1.89,0,0,1,.16,1.28.81.81,0,0,1-.53.48,2.36,2.36,0,0,1-.55.07A8.65,8.65,0,0,1,445.3,134.48Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441.55,135.36c.2,0,.21,1.37,1.39,2.35s2.66.83,2.67,1-.33.27-.95.28a3.45,3.45,0,0,1-2.23-.77,3,3,0,0,1-1.08-2C441.3,135.69,441.45,135.35,441.55,135.36Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441,120c-.13.34-1.4.18-2.89.36s-2.71.59-2.91.28c-.09-.15.12-.48.61-.81a4.8,4.8,0,0,1,2.15-.76,4.87,4.87,0,0,1,2.27.27C440.78,119.59,441.05,119.86,441,120Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M452.73,121.09c-.22.29-1.1,0-2.15,0s-1.95.19-2.16-.11c-.09-.15.05-.44.44-.71a3.15,3.15,0,0,1,3.48.11C452.71,120.65,452.83,121,452.73,121.09Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M458.81,107.88a3.05,3.05,0,0,0-1.13-2.74,2.17,2.17,0,0,0-2.81.21,2.53,2.53,0,0,0-2.18-3.07c-1.35-.09-2.51.93-3.81,1.29a6.14,6.14,0,0,1-3.88-.45c-1.23-.49-2.37-1.17-3.62-1.63a10.63,10.63,0,0,0-13.57,6.23,4.73,4.73,0,0,0-5,1.89,7.7,7.7,0,0,0-1.18,5.45,17.37,17.37,0,0,0,.95,3.72,1.71,1.71,0,0,0,0,.32c.08,4.56.6,9.92,2.54,10,3.4,0,2.59-6.34,2.59-6.34,4.16-1.61,2.61-7.85,3.65-8.79s3.22-3.15,11.94,1.31a16.92,16.92,0,0,0,10.34,1.11l.21,0h0l.08,0a7.7,7.7,0,0,0,2.23-1,4.35,4.35,0,0,0,1.84-2,2.4,2.4,0,0,0-.47-2.59A5.3,5.3,0,0,0,458.81,107.88Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M437.84,461.7l-.24-10.48-19.64.32.18,15.34,1.22.06c5.43.21,27.6.7,31.21-.46C454.59,465.19,437.84,461.7,437.84,461.7Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M446,463.69s5.88,1.6,5.16,2.57-23.14,1.33-33.05.62l0-.44,26.16-.19S444.89,463.76,446,463.69Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M417.86,466.43l.34,0,1,0,3.57.1c3,.06,7.19.09,11.79,0s8.78-.23,11.79-.38l3.57-.2,1-.07a1.23,1.23,0,0,0,.33-.05h-.34l-1,0-3.57.12c-3,.11-7.18.24-11.78.31s-8.77.07-11.79.05l-3.57,0h-1.31Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M444.33,466.56a8.23,8.23,0,0,1,.64-1.72,7.63,7.63,0,0,1,1.2-1.38,2.6,2.6,0,0,0-1.4,1.26A2.66,2.66,0,0,0,444.33,466.56Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M438.49,463.71c.06,0,.33-.31.61-.77s.46-.85.4-.88-.33.3-.61.76S438.43,463.67,438.49,463.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M436.89,462.89c0,.05.35-.16.68-.47s.57-.6.52-.65-.35.17-.68.47S436.84,462.84,436.89,462.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M435.85,461.05a2.25,2.25,0,0,0,1,.12,2.15,2.15,0,0,0,1-.13,2.49,2.49,0,0,0-1-.11A2.42,2.42,0,0,0,435.85,461.05Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M435.49,459.75a1.93,1.93,0,0,0,1.14.32,2,2,0,0,0,1.18-.18,6.12,6.12,0,0,0-1.16-.06A6.58,6.58,0,0,0,435.49,459.75Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M439.13,462a3.56,3.56,0,0,0,1.26,0,8.52,8.52,0,0,0,1.34-.32,3.5,3.5,0,0,0,.76-.33.68.68,0,0,0,.31-.4.48.48,0,0,0-.2-.5,2.32,2.32,0,0,0-2.85.72,2.4,2.4,0,0,0-.4.85.74.74,0,0,0,0,.34,3.9,3.9,0,0,1,.56-1.08,2.3,2.3,0,0,1,1.07-.72,2,2,0,0,1,1.5.08c.21.14.13.38-.09.52a4,4,0,0,1-.7.31,8.68,8.68,0,0,1-1.3.36C439.61,461.94,439.13,462,439.13,462Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M439.46,462a1.27,1.27,0,0,0,.13-.88,2.06,2.06,0,0,0-.36-.91,1.27,1.27,0,0,0-1.06-.63.5.5,0,0,0-.38.59,1.34,1.34,0,0,0,.22.56,3.73,3.73,0,0,0,.61.75,1.76,1.76,0,0,0,.73.5s-.25-.22-.61-.61a4.27,4.27,0,0,1-.54-.75c-.18-.27-.3-.74,0-.81s.65.28.84.53a1.94,1.94,0,0,1,.37.81A5.34,5.34,0,0,1,439.46,462Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M418.18,461.05c0,.05.56-.06,1.45,0a6.2,6.2,0,0,1,5.21,4c.31.84.35,1.4.39,1.4s0-.14,0-.4a5.49,5.49,0,0,0-.23-1.05,6.17,6.17,0,0,0-2-2.9,6.1,6.1,0,0,0-3.32-1.24,5.49,5.49,0,0,0-1.08,0A1.25,1.25,0,0,0,418.18,461.05Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M420.08,452.85a35.84,35.84,0,0,0-.1,4,31.92,31.92,0,0,0,.13,4,37.44,37.44,0,0,0,.11-4A32.72,32.72,0,0,0,420.08,452.85Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M427.71,464.66a16,16,0,0,0,5.74,0c0-.07-1.29,0-2.87,0S427.71,464.59,427.71,464.66Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M423.86,464.71c-.05.05.11.27.24.56s.21.56.28.55.1-.31-.06-.65S423.9,464.66,423.86,464.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M422.38,462.93c-.05,0,.08.25.29.45s.41.33.45.28-.08-.25-.29-.45S422.42,462.88,422.38,462.93Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M420.29,462.14c0,.06.27.06.56.15s.5.25.55.2-.11-.31-.47-.42S420.27,462.08,420.29,462.14Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M418.8,461.77c0,.06.1.16.26.22s.31.06.34,0-.09-.16-.26-.22S418.83,461.71,418.8,461.77Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "382.84 408.38 402.46 407.75 402.39 405.38 382.67 407.14 382.84 408.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M480,461.68l-.29-10.48-19.64.42.27,15.34,1.22.06c5.42.18,27.6.55,31.2-.63C496.79,465.08,480,461.68,480,461.68Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M488.22,463.63s5.89,1.57,5.18,2.54-23.13,1.45-33,.79l0-.44,26.16-.32S487.08,463.71,488.22,463.63Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460.07,466.52l.34,0,1,0,3.57.08c3,0,7.19.05,11.79,0s8.77-.27,11.79-.44l3.56-.22,1-.08.34,0a1.8,1.8,0,0,0-.34,0l-1,0-3.57.15c-3,.13-7.18.27-11.78.37s-8.77.11-11.79.11h-4.54Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M486.54,466.51a7.67,7.67,0,0,1,.63-1.72,8.13,8.13,0,0,1,1.19-1.39,2.59,2.59,0,0,0-1.39,1.27A2.62,2.62,0,0,0,486.54,466.51Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.68,463.69c.06,0,.33-.31.61-.77a2.16,2.16,0,0,0,.4-.89c-.06,0-.33.31-.61.77A2.21,2.21,0,0,0,480.68,463.69Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.08,462.88c0,.05.35-.17.68-.48s.56-.6.52-.65-.35.17-.68.48S479,462.83,479.08,462.88Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M478,461.05a4.48,4.48,0,0,0,2.06,0,2.23,2.23,0,0,0-1-.11A2.17,2.17,0,0,0,478,461.05Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M477.66,459.75a2,2,0,0,0,1.15.31,2.06,2.06,0,0,0,1.18-.19,6.75,6.75,0,0,0-1.17-.05A6,6,0,0,0,477.66,459.75Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M481.32,462a3.43,3.43,0,0,0,1.26,0,7.77,7.77,0,0,0,1.33-.33,3.57,3.57,0,0,0,.77-.33.69.69,0,0,0,.3-.4.5.5,0,0,0-.2-.5,2.31,2.31,0,0,0-2.85.74,2.21,2.21,0,0,0-.39.85.74.74,0,0,0,0,.34,3.83,3.83,0,0,1,.55-1.09,2.3,2.3,0,0,1,1.07-.72,1.91,1.91,0,0,1,1.5.07c.21.14.13.38-.09.52a4,4,0,0,1-.7.31,8.73,8.73,0,0,1-1.29.37C481.8,461.91,481.31,461.92,481.32,462Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M481.64,462a1.25,1.25,0,0,0,.13-.88,2.23,2.23,0,0,0-.36-.92,1.3,1.3,0,0,0-1.07-.62.49.49,0,0,0-.37.59,1.34,1.34,0,0,0,.22.56,4.11,4.11,0,0,0,.61.75,1.89,1.89,0,0,0,.74.5s-.26-.22-.62-.62a4.3,4.3,0,0,1-.54-.74c-.18-.27-.31-.74,0-.81s.64.27.84.52a2.08,2.08,0,0,1,.37.81A4.29,4.29,0,0,1,481.64,462Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460.36,461.14s.56-.07,1.45,0a6.17,6.17,0,0,1,5.23,4c.32.84.36,1.4.4,1.39s0-.14,0-.39a4.88,4.88,0,0,0-.23-1.06,6,6,0,0,0-5.38-4.1,5.54,5.54,0,0,0-1.08.05C460.49,461.08,460.36,461.12,460.36,461.14Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M462.22,452.92a36.38,36.38,0,0,0-.08,4,33.67,33.67,0,0,0,.15,4,34.6,34.6,0,0,0,.09-4A32.74,32.74,0,0,0,462.22,452.92Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M469.91,464.69a10.78,10.78,0,0,0,2.87.22,10.42,10.42,0,0,0,2.87-.29c0-.06-1.29,0-2.87.06S469.91,464.62,469.91,464.69Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M466.06,464.76c-.05.05.11.27.24.57s.22.55.29.54.09-.31-.07-.65S466.1,464.72,466.06,464.76Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M464.57,463c-.05.05.08.25.29.45s.41.33.46.28-.09-.25-.29-.45S464.61,462.94,464.57,463Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M462.48,462.21c0,.06.27.06.56.15s.5.25.55.2-.12-.31-.48-.42S462.45,462.15,462.48,462.21Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M461,461.85c0,.06.09.16.26.22s.31.06.33,0-.09-.16-.25-.22S461,461.79,461,461.85Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "425.02 408.47 444.63 407.73 444.56 405.36 424.84 407.23 425.02 408.47"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M483.66,197.38S487.27,219,489.77,220c13.82,5.46,30.37,5.05,36.23,4.69.72-.46,1.55-1,2.49-1.75a8.8,8.8,0,0,0,2.07-2.23,13.87,13.87,0,0,0,1.78-3.38,1.15,1.15,0,0,1,2.17-.34c.38,1-.53,3.61-2.2,7.19,0,0-.93,1.9.76,2.5s12.43,4.53,13.31,5.57.62,2.2-.69,2.23-8.21-1.9-8.21-1.9,9,2,9.09,3c.14,1.51-3.23,1.64-9.09-.53,0,0,9.42.89,8.86,3.14-.28,1.11-8.71-.81-8.71-.81-.74,1,8.71.89,8.67,2.33,0,.67-1.32,1.09-5.75.82-2.67-.17-7.08-.5-11.47-.79v.06s-56.22,8.36-60.75-16.81c-3.06-17-2.08-16.61-3.15-25.69",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M532.65,235.81c-.07.05-.39-.39-1-1a7,7,0,0,0-2.91-1.59l-.62-.17.55-.37c.12-.09.27-.17.4-.27a8.44,8.44,0,0,0,2.44-2.72c.47-.83.66-1.4.75-1.38a2.94,2.94,0,0,1-.37,1.57,7.4,7.4,0,0,1-2.48,3l-.44.29-.07-.54a6.31,6.31,0,0,1,3,1.87C532.51,235.25,532.71,235.78,532.65,235.81Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M545.09,234.64c-.07.16-1.93-.5-4.25-1.21s-4.23-1.22-4.2-1.39a19.74,19.74,0,0,1,8.45,2.6Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M545,236.72a62.91,62.91,0,0,1-7.63-1.84,10.42,10.42,0,0,1,3.93.46A10.18,10.18,0,0,1,545,236.72Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "378.88 201.32 378.88 407.24 409.47 406.06 412.1 226.19 422.48 406.78 453.65 408.29 438.29 203.12 378.88 201.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M450,255.29a19.09,19.09,0,0,1,.26,3.5c.08,2.16.16,5.15.21,8.45,0,1.65,0,3.21,0,4.66a9.14,9.14,0,0,1-.64,3.82,4.25,4.25,0,0,1-1.73,2c-.56.3-.92.31-.92.28s.31-.13.8-.47a4.45,4.45,0,0,0,1.47-1.94,9.4,9.4,0,0,0,.48-3.66c0-1.45-.06-3-.09-4.65-.05-3.3-.05-6.29,0-8.45A21.24,21.24,0,0,1,450,255.29Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M445.37,257.59c.06.07-.4.34-.42,1a1.18,1.18,0,0,0,.44,1,1.06,1.06,0,0,0,1.22-.09.93.93,0,0,0,.07-1.53,1.27,1.27,0,0,0-1.23-.3l0-.23c.25.13.38.22.37.26s-.17,0-.45,0l-.25-.05.23-.18a1.47,1.47,0,0,1,1.66.13,1.5,1.5,0,0,1,.62,1.11A1.48,1.48,0,0,1,447,260a1.59,1.59,0,0,1-1.89.05,1.52,1.52,0,0,1-.53-1.44,1.42,1.42,0,0,1,.49-.89C445.22,257.57,445.36,257.56,445.37,257.59Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M445.15,452.55c0,.17-6.86.3-15.31.3s-15.32-.13-15.32-.3,6.86-.29,15.32-.29S445.15,452.39,445.15,452.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M487.7,451.38c0,.17-6.81.3-15.2.3s-15.19-.13-15.19-.3,6.8-.29,15.19-.29S487.7,451.22,487.7,451.38Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M430,256.89c.15,0,.26,43.48.26,97.11s-.11,97.12-.26,97.12-.26-43.47-.26-97.12S429.82,256.89,430,256.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M463.91,256.89c.14,0,2.4,43.19,5,96.47s4.67,96.49,4.53,96.5-2.4-43.18-5.05-96.48S463.76,256.89,463.91,256.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M439,280a13.12,13.12,0,0,1-3.59.21,8.79,8.79,0,0,1-2.82-.61l-1.18-.5a10.14,10.14,0,0,1-4.25-3.53c-4.65-6.8-18.64-27.41-20.57-31.91-2.32-5.41,6.4-46.82,6.4-46.82l-17.2-5.59s-8.35,36.42-7.9,54.34c.28,11.41,31.55,42.89,31.58,42.92a104.2,104.2,0,0,0,5.66,9.86c3.08,4.33,3.47,4.06,3.91,3.62,1.19-1.19-5.12-7.83-2.94-7.19s6.78,9,8,7.72c1.56-1.7-5.18-8.52-5.71-9.14s.35-1.41.8-.82c.64.84,7.59,9.51,9.14,7.86.86-.91-.93-2.3-.93-2.3s-7.1-7.63-6.35-8.38,5.09,3.57,6.45,5.14,2.61,1.54,2.81.38c.13-.8-3.91-5.69-5.28-7.21s-5.22-5.61-1.68-5.14,6.43-.49,7-1.3S440,279.69,439,280Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M415.4,199.35l-.19,25.3-1.35,29.07,59.94,1.55-3.87-31.2-1.54-29.54S473.08,175,471.93,172a12.24,12.24,0,0,0-7.27-7.44c-.78-.45-11.82-4-15.91-4.21l0-7.72c-6.87.68-10.42,8.8-10.42,8.8-2.85-6.87-13.55-7.87-13.55-7.87l.2,7.1a50.07,50.07,0,0,0-11.21,2.05c-6,2.16-9.26,3.7-13.72,8.15-3.07,3.07-5.68,14.28-6.48,19.46",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M436.33,158.73a2.9,2.9,0,0,0-2,.26,3.41,3.41,0,0,0-1.42,1.65,7.7,7.7,0,0,0-.45,1.28l-.19.71a1.82,1.82,0,0,1-.38.82.86.86,0,0,1-.53.26,1.09,1.09,0,0,1-.5-.1c-.26-.11-.46-.22-.69-.32l-1.25-.62-2.12-1.08a8,8,0,0,1-1.88-1.13,8.48,8.48,0,0,1,2.06.75l2.17,1,1.27.59.66.3c.21.08.29.07.38,0a5.1,5.1,0,0,0,.44-1.28,8,8,0,0,1,.51-1.35,3.68,3.68,0,0,1,1.73-1.79,2.43,2.43,0,0,1,1.66-.19C436.19,158.54,436.35,158.7,436.33,158.73Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M448.9,159.92a31.79,31.79,0,0,1-4.64,3.86l-.39.29-.08-.48-.11-.6a7,7,0,0,0-1.74-4.1,6.3,6.3,0,0,0-1.58-1c0-.06.86-.13,1.86.69a4.8,4.8,0,0,1,1.32,1.75,10.51,10.51,0,0,1,.73,2.55c0,.21.07.42.1.61l-.47-.18A34,34,0,0,1,448.9,159.92Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M466,165.15s9.86,3.35,14.13,16.64a205.6,205.6,0,0,1,6.38,25.92l-16.76,5.67-6.27-38.16Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M486.52,207.71s1.76,7.81,2.77,9.24.71,2.56,8.61,4.41,17.84,2.87,21.32,2.46l2.46.09,1.64,17.3s-19.78,2.81-33.11-.57-19.18-8-19.9-11S468.88,212,468.88,212Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.92,160.46s7.24,7.47,8.25,6.36,1.45-8.29,4.4-6.86a2.85,2.85,0,0,0-1.83-1.31c-1.12-.12-2.93-.28-3.82,3.82,0,0,0,1.28-1,.9S424.92,160.46,424.92,160.46Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.45,159.45a2,2,0,0,1,1.9,1.58,47.39,47.39,0,0,1,.49,5.9l6.43-6.34-4.22,2.93s-.57-5-3.69-5.63Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M414.74,223.49",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416,286.76l13.47-12.65s-20.21-26.9-20.93-31.8,7.11-45.46,7.11-45.46l-21.8-8.27s-8.43,40-8.42,57.35C385.48,254.06,416,286.76,416,286.76Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M480.62,183.15a4.35,4.35,0,0,1-.81-.35,10,10,0,0,0-1-.43,12.09,12.09,0,0,0-1.36-.5,25.86,25.86,0,0,0-9.12-1.16,67.15,67.15,0,0,0-13.54,2.22c-5,1.15-10.69,2.55-16.75,2.11s-11.49-2.48-16.41-4.06a60.24,60.24,0,0,0-13.33-3.2,25.8,25.8,0,0,0-9.17.62,11.74,11.74,0,0,0-1.39.42,9,9,0,0,0-1,.36,5.05,5.05,0,0,1-.83.31,14.6,14.6,0,0,1,3.16-1.29,24.74,24.74,0,0,1,9.26-.78,59.07,59.07,0,0,1,13.45,3.1c4.93,1.56,10.35,3.54,16.3,4s11.56-.94,16.6-2.06a66.2,66.2,0,0,1,13.64-2.12,25.14,25.14,0,0,1,9.2,1.34A14.54,14.54,0,0,1,480.62,183.15Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M412.16,209.45a15.18,15.18,0,0,1-3.15,0,65.46,65.46,0,0,1-7.54-1,64.71,64.71,0,0,1-7.38-1.84,16.1,16.1,0,0,1-2.95-1.11,22.77,22.77,0,0,1,3.05.75c1.88.5,4.47,1.14,7.38,1.69s5.55.89,7.48,1.11A26.47,26.47,0,0,1,412.16,209.45Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,209.25a3.09,3.09,0,0,1-.47.56,9.4,9.4,0,0,1-1.63,1.32,13.66,13.66,0,0,1-7.39,2c-3.3.08-7.1-1-11.13-2.43a64.8,64.8,0,0,0-6.39-1.94,36.4,36.4,0,0,0-7.1-.81c-1.23-.07-2.45,0-3.64,0s-2.38.14-3.53.29c-2.31.23-4.53.57-6.65.87-4.23.64-8.06,1.19-11.31,1.4a47.92,47.92,0,0,1-7.68-.07c-.9-.11-1.6-.23-2.07-.31a6,6,0,0,1-.71-.14,3.09,3.09,0,0,1,.73,0l2.07.21a52.87,52.87,0,0,0,7.64-.1c3.22-.26,7-.84,11.26-1.5,2.11-.32,4.34-.67,6.66-.91,1.16-.15,2.36-.2,3.56-.3s2.43-.12,3.68-.05a36,36,0,0,1,7.2.83,62.56,62.56,0,0,1,6.44,2c4,1.43,7.74,2.55,11,2.51a13.89,13.89,0,0,0,7.29-1.75A16,16,0,0,0,486,209.25Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M408.93,241.2c0,.09-1.25-.28-3.27-.7a43.9,43.9,0,0,0-8-.9,43.16,43.16,0,0,0-8,.61c-2,.34-3.27.67-3.29.58a3.05,3.05,0,0,1,.84-.32,22.77,22.77,0,0,1,2.38-.62,35.36,35.36,0,0,1,8.08-.77,35.84,35.84,0,0,1,8.05,1.06,23.15,23.15,0,0,1,2.35.71A3,3,0,0,1,408.93,241.2Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M471,241.17c0,.05-.64-.5-1.87-1.3a22.37,22.37,0,0,0-5.58-2.57,30.62,30.62,0,0,0-9-1.27,56.07,56.07,0,0,0-11.13,1.36c-3.91.82-7.61,1.78-11,2.48a63.56,63.56,0,0,1-9.15,1.31,34.1,34.1,0,0,1-6.22-.17c-.73-.1-1.3-.19-1.67-.28a2.5,2.5,0,0,1-.58-.15c0-.05.81.1,2.27.23a37.88,37.88,0,0,0,6.18,0,65.82,65.82,0,0,0,9.07-1.41c3.39-.72,7.08-1.69,11-2.52a54.57,54.57,0,0,1,11.24-1.33,30.4,30.4,0,0,1,9.14,1.39,21.36,21.36,0,0,1,5.59,2.76,15.16,15.16,0,0,1,1.32,1.06A3.43,3.43,0,0,1,471,241.17Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M502,223.37a2.2,2.2,0,0,1,.17.79,13.24,13.24,0,0,1,.14,2.17,20.15,20.15,0,0,1-5.1,13.16,12.83,12.83,0,0,1-1.57,1.51,2.73,2.73,0,0,1-.65.47c-.06-.07.79-.82,1.94-2.22a22.25,22.25,0,0,0,5-12.93C502,224.51,501.91,223.38,502,223.37Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M421,263.53c0,.09-1.07.31-2.75.84a30.6,30.6,0,0,0-11.81,6.89c-1.29,1.21-2,2.05-2.07,2s.12-.25.42-.65a19.4,19.4,0,0,1,1.4-1.6,25.59,25.59,0,0,1,5.5-4.3,26.33,26.33,0,0,1,6.46-2.69,17.14,17.14,0,0,1,2.07-.42A2.56,2.56,0,0,1,421,263.53Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M518.94,224.23a10.22,10.22,0,0,1,.72,2.5,37.08,37.08,0,0,1,.73,6.24,35.3,35.3,0,0,1-.37,6.28,9.7,9.7,0,0,1-.57,2.54,17.5,17.5,0,0,1,.21-2.59,49,49,0,0,0-.37-12.41A16.6,16.6,0,0,1,518.94,224.23Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M443.48,176c-.05-.06.45-.28,1,.19a1.35,1.35,0,0,1,.45,1.13,1.32,1.32,0,1,1-2.53-.65c.29-.66.83-.69.81-.61s-.31.24-.42.74a1,1,0,0,0,.14.78.81.81,0,0,0,.83.25.78.78,0,0,0,.63-.59,1,1,0,0,0-.21-.75C443.87,176,443.48,176,443.48,176Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445.67,197.15c-.05-.07.45-.28,1,.19a1.34,1.34,0,0,1,.45,1.13,1.37,1.37,0,0,1-2.45.56,1.32,1.32,0,0,1-.08-1.21c.29-.66.83-.69.81-.61s-.31.24-.42.74a1,1,0,0,0,.14.77.87.87,0,0,0,1.46-.33,1,1,0,0,0-.21-.76C446.06,197.23,445.67,197.24,445.67,197.15Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M447,217.84c0-.07.45-.28,1,.19a1.35,1.35,0,0,1,.45,1.13,1.37,1.37,0,0,1-2.45.56,1.35,1.35,0,0,1-.09-1.21c.3-.66.83-.69.82-.61s-.31.24-.42.74a1,1,0,0,0,.14.78.8.8,0,0,0,.83.25.78.78,0,0,0,.63-.59,1,1,0,0,0-.21-.75C447.41,217.92,447,217.93,447,217.84Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M448.38,240.36c0-.07.45-.28,1,.19a1.39,1.39,0,0,1,.46,1.13,1.32,1.32,0,0,1-1,1.08,1.28,1.28,0,0,1-1.41-.52,1.32,1.32,0,0,1-.08-1.21c.29-.66.83-.69.81-.61s-.31.24-.42.74a1,1,0,0,0,.14.77.86.86,0,0,0,1.46-.33,1,1,0,0,0-.21-.76C448.77,240.44,448.38,240.45,448.38,240.36Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M444.89,251.59a5.41,5.41,0,0,1-.09-.91c0-.66-.08-1.54-.14-2.63-.12-2.35-.29-5.64-.49-9.68-.42-8.17-1.11-19.44-2.06-31.88s-1.95-23.71-2.67-31.85c-.35-4-.64-7.31-.84-9.65-.09-1.1-.16-2-.21-2.63a5.32,5.32,0,0,1,0-.92,5.63,5.63,0,0,1,.15.91c.08.65.19,1.52.32,2.61.25,2.34.6,5.61,1,9.64.83,8.14,1.9,19.39,2.85,31.84s1.58,23.74,1.89,31.91c.16,4.09.26,7.4.3,9.69,0,1.1,0,2,0,2.63A5.35,5.35,0,0,1,444.89,251.59Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M473,247a2,2,0,0,1-.14-.58c-.08-.45-.19-1-.31-1.68-.26-1.46-.59-3.58-1-6.21-.78-5.25-1.73-12.52-2.72-20.55s-1.91-15.3-2.67-20.55l-.92-6.21c-.09-.68-.17-1.24-.24-1.69s-.07-.6,0-.6a2.54,2.54,0,0,1,.16.58c.09.44.21,1,.35,1.67.29,1.45.68,3.57,1.11,6.19.86,5.23,1.85,12.5,2.84,20.54s1.89,15.22,2.55,20.57c.32,2.56.59,4.67.79,6.23.08.68.14,1.24.2,1.69A2.48,2.48,0,0,1,473,247Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.28,194.72c3.42,11.8,4.54,22.15,11,31.89a30,30,0,0,0,8.92,8.76c6.93,4.41,15.31,5.87,23.49,6.64h5.53s-12.44,1.05-22.5-.8c0,0-15.47-2.76-21.53-9.86Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.29 137.38 386.64 201.58 378.51 201.58 379.72 175.08 380.05 146.67 381.29 137.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M415.46,198.76a7.6,7.6,0,0,1,.11-1.53c.12-1.1.28-2.49.46-4.15s.39-3.84.59-6.17c.08-1.16.18-2.38.27-3.64a23.9,23.9,0,0,0,0-3.88,8.67,8.67,0,0,0-1.1-3.61,7.87,7.87,0,0,0-2.46-2.48,12.46,12.46,0,0,0-5.74-1.81,36,36,0,0,0-4.16-.07,7.88,7.88,0,0,1-1.53,0,7.34,7.34,0,0,1,1.52-.22,27.14,27.14,0,0,1,4.2-.12,12.53,12.53,0,0,1,6,1.77,8.3,8.3,0,0,1,2.67,2.64,8.91,8.91,0,0,1,1.19,3.85,24,24,0,0,1,0,4c-.09,1.27-.2,2.49-.31,3.65-.22,2.33-.47,4.42-.71,6.17s-.47,3.16-.65,4.13A7.34,7.34,0,0,1,415.46,198.76Z",
    transform: "translate(-35.35 -52.14)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346,378.82c.49,1.94,5.2,85,5.2,85l17.42-1.3,1.14-83.67Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M369.19,463.5l-.05-1.83-18.58.38.11,6.05,1.15,0c5.11.16,26,.51,29.38-.51C385,466.49,369.19,463.5,369.19,463.5Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.38,467.84a6,6,0,0,0-2.45-3.62,6.56,6.56,0,0,0-4.35-1.17l.11,4.8Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.91,465.22s5.54,1.37,4.88,2.23-21.79,1.24-31.12.65l0-.38,24.63-.26S375.84,465.28,376.91,465.22Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M350.41,467.71a1.11,1.11,0,0,0,.31,0l.92,0,3.36.07c2.84.05,6.77.06,11.1,0s8.26-.22,11.1-.36l3.36-.2.91-.06a1.3,1.3,0,0,0,.31,0,1.23,1.23,0,0,0-.31,0l-.92,0-3.36.13c-2.84.1-6.76.23-11.09.3s-8.26.09-11.1.09h-4.28Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375.33,467.73a6.67,6.67,0,0,1,.59-1.5A7.43,7.43,0,0,1,377,465a2.48,2.48,0,0,0-1.31,1.11A2.16,2.16,0,0,0,375.33,467.73Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.81,465.25c.06,0,.31-.27.57-.67s.43-.74.38-.77-.31.27-.57.67S369.76,465.23,369.81,465.25Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.3,464.55s.33-.15.64-.42.53-.53.49-.57-.33.15-.64.42S368.26,464.5,368.3,464.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.32,462.94a2.3,2.3,0,0,0,1,.1,2.66,2.66,0,0,0,1-.11,2.15,2.15,0,0,0-1-.1A2.2,2.2,0,0,0,367.32,462.94Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367,461.8a2,2,0,0,0,1.08.27,2,2,0,0,0,1.11-.15,6,6,0,0,0-1.1-.05A6.31,6.31,0,0,0,367,461.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.41,463.74a3.46,3.46,0,0,0,1.19,0,7.63,7.63,0,0,0,1.26-.29,3.22,3.22,0,0,0,.71-.29.57.57,0,0,0,.29-.35.4.4,0,0,0-.19-.43A2.26,2.26,0,0,0,371,463a1.75,1.75,0,0,0-.37.74.58.58,0,0,0,0,.3,3.11,3.11,0,0,1,.52-1,2.13,2.13,0,0,1,1-.63,1.94,1.94,0,0,1,1.42.06c.19.13.13.33-.08.45a3.19,3.19,0,0,1-.66.28,10.16,10.16,0,0,1-1.22.32C370.86,463.7,370.41,463.71,370.41,463.74Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.72,463.79a1.11,1.11,0,0,0,.12-.77,1.78,1.78,0,0,0-.35-.8,1.2,1.2,0,0,0-1-.54.43.43,0,0,0-.35.51,1,1,0,0,0,.21.49,3,3,0,0,0,.58.66,1.78,1.78,0,0,0,.69.44s-.24-.2-.58-.54a3.36,3.36,0,0,1-.51-.66c-.17-.23-.29-.64,0-.7a1.09,1.09,0,0,1,.79.46,1.74,1.74,0,0,1,.35.71A4.07,4.07,0,0,1,370.72,463.79Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M350.68,463s.53-.06,1.36,0a6.2,6.2,0,0,1,3,1.09,5.53,5.53,0,0,1,1.92,2.41c.3.73.33,1.23.38,1.22a1.33,1.33,0,0,0,0-.35,4.88,4.88,0,0,0-.22-.92,5.36,5.36,0,0,0-1.93-2.53,6.13,6.13,0,0,0-3.13-1.07,5.89,5.89,0,0,0-1,0A1.09,1.09,0,0,0,350.68,463Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.67,466.12a11.19,11.19,0,0,0,2.7.2,11.38,11.38,0,0,0,2.7-.25c0-.06-1.21,0-2.7,0S359.67,466.06,359.67,466.12Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M356,466.18s.11.24.23.49.21.49.27.48.09-.27-.06-.57S356.08,466.14,356,466.18Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.64,464.63s.08.21.28.39.38.29.43.25-.08-.22-.28-.4S354.68,464.58,354.64,464.63Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.67,463.94c0,.06.26.05.53.14s.48.21.52.17-.11-.27-.45-.37S352.65,463.89,352.67,463.94Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.27,463.62c0,.06.09.14.24.2s.3.05.32,0-.09-.14-.24-.19S351.29,463.57,351.27,463.62Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M275.58,222.47a17.61,17.61,0,0,1,1.95-23.12l30.61-29.53L314,191.41c-.54.3-23.71,21.43-23.71,21.43l16.48,24.31a13.16,13.16,0,0,1,1.16,12.68l-1.09,3.29a8.11,8.11,0,0,1-11.6,4.55l-5-2.73a1.1,1.1,0,0,1-.34-1.63h0a1.11,1.11,0,0,1,1-.42l7,.56a3.18,3.18,0,0,0,3.28-2.16h0Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M290.67,213.47c-1.22-1.8-2.79-3.4-4-5",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M376.58,193.27l6.85,12.4,4.2-33.71a13.6,13.6,0,0,0-1.4-7.09,14.65,14.65,0,0,0-1.7-2.75,14.8,14.8,0,0,0-2.94-2.75c-1.08-.61-.89-2.2.22-2.32s4.1,1.49,6.45,4.72,2.61-3,2.75-5.25.86-9.22,1.58-9.72c1.07-.72,2.06.31,1.88,2.57s-.26,9.06.93,9.1S397.09,147,397.09,147s-.29-2.49,1.09-2.49c2.49,0,1.05,12.19.88,13.35-.11.8,1.18.89,1.26,0s.25-11.51,2.78-11.52c1.94,0-1.1,10,.09,12.28s1.53-7.87,3.38-7.81c.7,0,1.21.14.18,5.9-.56,3.1-2.6,7.56-3.23,13.61l-.16,1.57s-3.45,29.53-8.64,47.53c-3.1,10.79-18.42,11.85-24.63,2.49-4.22-6.35-10.88-22.95-10.88-22.95Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M400.88,166.61c0,.06-.39,0-1,.26a3.57,3.57,0,0,0-1.91,1.59l-.24.42-.13-.47a6.1,6.1,0,0,0-.92-1.84,6.67,6.67,0,0,0-3.18-2.34c-1-.35-1.65-.33-1.64-.41a3.13,3.13,0,0,1,1.73.12,6.37,6.37,0,0,1,3.44,2.37,6.07,6.07,0,0,1,1,2l-.37,0a3.51,3.51,0,0,1,2.19-1.62A1.74,1.74,0,0,1,400.88,166.61Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M300.64,381.8c-.64,1.9-7.12,80-7.12,80L311,463l10.6-73.72Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M292.39,463.42l.06-1.83L311,462l-.11,6-1.15.05c-5.11.17-26,.52-29.38-.51C276.6,466.42,292.39,463.42,292.39,463.42Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.21,467.76a5.89,5.89,0,0,1,2.44-3.62A6.62,6.62,0,0,1,311,463l-.1,4.81Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.67,465.14s-5.54,1.37-4.87,2.23,21.78,1.24,31.11.65l0-.38-24.63-.26S285.75,465.2,284.67,465.14Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.18,467.63l-.32,0-.91,0-3.37.08c-2.84,0-6.76.05-11.1,0s-8.26-.23-11.09-.37l-3.36-.19-.91-.07-.32,0h.32l.91,0,3.36.12c2.84.11,6.76.23,11.1.31s8.25.08,11.09.08h4.6Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.26,467.65a4.54,4.54,0,0,0-1.72-2.72,2.49,2.49,0,0,1,1.32,1.11A2.22,2.22,0,0,1,286.26,467.65Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.77,465.18s-.31-.27-.57-.67-.43-.75-.38-.78.31.27.57.67S291.82,465.15,291.77,465.18Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.28,464.47s-.33-.15-.64-.42-.53-.52-.49-.57.33.15.64.42S293.33,464.43,293.28,464.47Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.27,462.86a2.36,2.36,0,0,1-1,.1,2.27,2.27,0,0,1-1-.11,2.36,2.36,0,0,1,1-.1A2.47,2.47,0,0,1,294.27,462.86Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.62,461.72a2,2,0,0,1-1.09.28,2,2,0,0,1-1.1-.16,5.93,5.93,0,0,1,1.09,0A7.94,7.94,0,0,1,294.62,461.72Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.18,463.67a4.09,4.09,0,0,1-1.19,0,7.2,7.2,0,0,1-1.26-.29,3.5,3.5,0,0,1-.72-.29.62.62,0,0,1-.29-.34.44.44,0,0,1,.19-.44,2.29,2.29,0,0,1,2.69.64,2.1,2.1,0,0,1,.37.74.63.63,0,0,1,0,.3,3.08,3.08,0,0,0-.52-.95,2.16,2.16,0,0,0-1-.63,1.94,1.94,0,0,0-1.42.06c-.19.13-.12.34.09.46a3.51,3.51,0,0,0,.66.27,7.07,7.07,0,0,0,1.21.32C290.72,463.62,291.18,463.63,291.18,463.67Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.87,463.71a1,1,0,0,1-.12-.76,1.65,1.65,0,0,1,.34-.81,1.2,1.2,0,0,1,1-.54.45.45,0,0,1,.36.52,1.29,1.29,0,0,1-.22.49,3.11,3.11,0,0,1-.57.65,1.71,1.71,0,0,1-.69.44s.24-.2.57-.54a4.1,4.1,0,0,0,.52-.65c.16-.23.29-.65,0-.71a1.06,1.06,0,0,0-.79.46,1.65,1.65,0,0,0-.36.71A3.48,3.48,0,0,0,290.87,463.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.91,462.92s-.53-.06-1.37,0a6.3,6.3,0,0,0-3,1.09,5.63,5.63,0,0,0-1.91,2.41c-.3.73-.34,1.23-.38,1.22s0-.12,0-.34a3.65,3.65,0,0,1,.22-.93,5.36,5.36,0,0,1,1.93-2.53,6.07,6.07,0,0,1,3.13-1.07,4.79,4.79,0,0,1,1,0A1.2,1.2,0,0,1,310.91,462.92Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.92,466a10.73,10.73,0,0,1-2.71.2,10.87,10.87,0,0,1-2.7-.25c0-.06,1.22,0,2.71,0S301.91,466,301.92,466Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.54,466.1s-.1.24-.23.5-.2.48-.27.47-.09-.27.07-.56S305.5,466.06,305.54,466.1Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.94,464.55c.05,0-.08.22-.27.39s-.39.29-.43.25.08-.22.27-.4S306.9,464.51,306.94,464.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.91,463.86c0,.06-.26.05-.53.14s-.47.21-.52.17.11-.27.45-.37S308.93,463.81,308.91,463.86Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.31,463.55c0,.05-.08.14-.24.19s-.3.05-.32,0,.09-.14.24-.2S310.29,463.49,310.31,463.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.45,230.83l-12.26,28.64L289.44,457.41h31.68l17.59-172.34L346,458.13l29.25-2.48-4.06-196A31.24,31.24,0,0,0,368.08,247L360,230.42Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M363.24,237.14c0,.15-11.09.26-24.77.26s-24.78-.11-24.78-.26,11.09-.26,24.78-.26S363.24,237,363.24,237.14Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M338.16,287.35c-.14,0-.26-11.16-.26-24.94s.12-24.94.26-24.94.26,11.17.26,24.94S338.31,287.35,338.16,287.35Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.8,236.5a2.66,2.66,0,0,1,0,.52c0,.39,0,.88,0,1.47,0,1.36,0,3.19,0,5.42,0,4.57,0,10.89-.12,17.86,0,3.49-.08,6.81-.12,9.84a46.4,46.4,0,0,1-.49,8,9.73,9.73,0,0,1-2.24,4.94,4.86,4.86,0,0,1-1.6,1.19,12.62,12.62,0,0,0,1.44-1.33,9.77,9.77,0,0,0,2-4.86,50.92,50.92,0,0,0,.37-8c0-3,.05-6.35.08-9.84.08-7,.18-13.3.27-17.87.06-2.23.11-4.06.14-5.41,0-.59.05-1.08.07-1.48A1.77,1.77,0,0,1,342.8,236.5Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M390.59,227.08c-.14,0-.26-11.4-.26-25.46s.12-25.46.26-25.46.26,11.4.26,25.46S390.74,227.08,390.59,227.08Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360,230.42s.35-30.18.3-30.68l19.51-2.24s-6-22.56-9.24-26.78c-8.51-11-22-9-22-9l-20.13-.24a14.89,14.89,0,0,0-1.72-.29,20.77,20.77,0,0,0-16.41,5.33l-21.89,22.44L303,201.62,314,197.05l2.5,33.78Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.82,220.69a41.7,41.7,0,0,0,1.25,5.44,42.08,42.08,0,0,0,2.44,5,11.44,11.44,0,0,1-2.93-4.84A11.6,11.6,0,0,1,330.82,220.69Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.46,224.79a11.12,11.12,0,0,1,.13,3.34,10.75,10.75,0,0,1-.38,3.32,11.26,11.26,0,0,1-.14-3.34A10.63,10.63,0,0,1,337.46,224.79Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "285.77 112.42 285.47 178.65 294.73 178.69 285.77 112.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M355.82,162l2.69,72.15h6.17l-1.41-25.64,5.13,12.42a15.42,15.42,0,0,0,14.38,9.54h0a15.42,15.42,0,0,0,15-12.43l5-34.13-16.94-11.39-3.61,29.09-8.55-25.16a22.31,22.31,0,0,0-11.87-13.3A11,11,0,0,0,355.82,162Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.62,227.66a13.28,13.28,0,0,1-5.23,0,13.28,13.28,0,0,1,5.23,0Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.8,217.56a17.7,17.7,0,0,1-6.16,0,18.37,18.37,0,0,1,6.16,0Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M398.38,217.38c0,.14-7,.26-15.61.26s-15.6-.12-15.6-.26,7-.26,15.6-.26S398.38,217.23,398.38,217.38Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M400.43,202.05c0,.15-9.66.26-21.58.26s-21.59-.11-21.59-.26,9.67-.26,21.59-.26S400.43,201.91,400.43,202.05Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M376.51,185.42a92.37,92.37,0,0,1-9.9.26,92.65,92.65,0,0,1-9.91-.26,95.91,95.91,0,0,1,9.91-.26A95.62,95.62,0,0,1,376.51,185.42Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370,170.1a92.09,92.09,0,0,1-13.83,0,92.09,92.09,0,0,1,13.83,0Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365.84,216.12c-.14,0-.26-10.89-.26-24.31s.12-24.31.26-24.31.26,10.88.26,24.31S366,216.12,365.84,216.12Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.39,227.61c-.14,0-.26-7.88-.26-17.59s.12-17.59.26-17.59.26,7.87.26,17.59S378.54,227.61,378.39,227.61Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.16,163.88c.14,0,.26,10.11.26,22.57S363.3,209,363.16,209s-.26-10.1-.26-22.56S363,163.88,363.16,163.88Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M391.81,226.71a2.5,2.5,0,0,1-.4.32,8,8,0,0,1-1.27.75,10.75,10.75,0,0,1-5.28,1,10.39,10.39,0,0,1-3.66-.84,11.31,11.31,0,0,1-3.55-2.46c-2.17-2.18-3.69-5.2-5.18-8.31-3-6.24-5.4-12-7-16.29-.8-2.13-1.41-3.86-1.81-5.06l-.45-1.4a3,3,0,0,1-.12-.49,1.7,1.7,0,0,1,.22.46c.15.36.33.81.54,1.36l2,5c1.68,4.21,4.11,10,7.12,16.2,1.49,3.11,3,6.08,5.05,8.2a10.47,10.47,0,0,0,6.89,3.28,11.13,11.13,0,0,0,5.18-.86C391.21,227.09,391.78,226.66,391.81,226.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M382.15,213.27a34.9,34.9,0,0,1-.26-6.07,35,35,0,0,1,.26-6.08,36.2,36.2,0,0,1,.26,6.08A36.13,36.13,0,0,1,382.15,213.27Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M311.22,164.83l-35.44,35.84a16.59,16.59,0,0,0-1.49,22.19L297.73,249l4.58-20.69-10.69-14.88,20.23-11.79-.56,32.54,9.83,1.36V161S315.27,160.92,311.22,164.83Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M321.38,186c0,.15-6.94.26-15.51.26s-15.51-.11-15.51-.26,6.95-.26,15.51-.26S321.38,185.84,321.38,186Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.82,171a56.72,56.72,0,0,1-7.75.26,56.81,56.81,0,0,1-7.76-.26,58.81,58.81,0,0,1,7.76-.26A58.71,58.71,0,0,1,320.82,171Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.26,201.12c0,.14-9.87.26-22.05.26s-22-.12-22-.26,9.87-.26,22-.26S320.26,201,320.26,201.12Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.64,218.87a38.81,38.81,0,0,1-9,0,38.81,38.81,0,0,1,9,0Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M295.22,218.13c0,.14-5.19.26-11.58.26s-11.59-.12-11.59-.26,5.19-.26,11.59-.26S295.22,218,295.22,218.13Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M301.39,232.33a81.91,81.91,0,0,1-9.16.26,81.91,81.91,0,0,1-9.16-.26,79.13,79.13,0,0,1,9.16-.26A79.13,79.13,0,0,1,301.39,232.33Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M321,232.33a45.55,45.55,0,0,1-9.72,0,45.55,45.55,0,0,1,9.72,0Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M301.13,207.45c-.14,0-.26-7.16-.26-16s.12-16,.26-16,.26,7.17.26,16S301.28,207.45,301.13,207.45Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M287.87,209.22c-.14,0-.26-4.59-.26-10.25s.12-10.26.26-10.26a99.18,99.18,0,0,1,.26,10.26A99.06,99.06,0,0,1,287.87,209.22Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.39,227.79c-.15,0-.26-6.81-.26-15.21s.11-15.2.26-15.2.26,6.8.26,15.2S279.53,227.79,279.39,227.79Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.35,242.81c-.14,0-.26-5.74-.26-12.81s.12-12.82.26-12.82.27,5.74.27,12.82S293.5,242.81,293.35,242.81Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.34,162.55c.14,0,.26,16.11.26,36s-.12,36-.26,36-.26-16.1-.26-36S316.19,162.55,316.34,162.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.72,164.71c.15,0,.26,8.42.26,18.8s-.11,18.81-.26,18.81-.26-8.42-.26-18.81S311.58,164.71,311.72,164.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295,218.07a48.52,48.52,0,0,1-4.52-5.63,51,51,0,0,1-4.1-5.94,48.52,48.52,0,0,1,4.52,5.63A52,52,0,0,1,295,218.07Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.89,112.45a8.91,8.91,0,0,1,13.26,2.82,14,14,0,0,1,1.16,8c-.26,2.72-.87,5.4-.93,8.13-.08,3.51.73,7.15-.44,10.46a9.14,9.14,0,0,1-13.42,4.72c-2.49-1.54-4.07-4.15-5.53-6.68-1.88-3.28-3.73-6.66-4.39-10.38s0-7.88,2.69-10.56",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348,160.72c-.44-5.56-6.86-2.18-6.14-7.71a233.92,233.92,0,0,0,1.8-37.6",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M330.22,159.72l-4.13-36.86c4.23-5.8,9.44-8.55,15.52-8.83a11.31,11.31,0,0,1,11.45,9.24c1.19,6.07,2.51,14.26,2.21,19.29-.55,9.2-7.38,11-7.38,11s.24,3.1.58,6.89c1.76.29,4.61.76,6.55,1.24.09,0-.07.37-.42,1a19,19,0,0,1-30.16,2.95l-3-4.41S325.84,160.4,330.22,159.72Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.53,129.8a1.17,1.17,0,0,1-1,1.29,1.13,1.13,0,0,1-1.31-.93,1.18,1.18,0,0,1,1-1.29A1.12,1.12,0,0,1,352.53,129.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.76,128.8c-.13.17-1.07-.4-2.32-.27s-2.11.84-2.26.7.05-.35.42-.68a3.26,3.26,0,0,1,1.79-.75,3.08,3.08,0,0,1,1.87.41C352.67,128.47,352.83,128.73,352.76,128.8Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.75,131.37a1.17,1.17,0,0,1-1,1.29,1.12,1.12,0,0,1-1.3-.93,1.18,1.18,0,0,1,1-1.29A1.12,1.12,0,0,1,339.75,131.37Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340,130.26c-.13.17-1.07-.39-2.32-.27s-2.11.84-2.26.7.05-.35.42-.68a3.34,3.34,0,0,1,1.79-.75,3.08,3.08,0,0,1,1.87.41C339.87,129.93,340,130.19,340,130.26Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.57,138.89a7.5,7.5,0,0,1,2-.57c.31-.07.61-.16.64-.38a1.61,1.61,0,0,0-.31-.93l-1.18-2.34a42.76,42.76,0,0,1-2.75-6.15,41,41,0,0,1,3.24,5.92l1.15,2.36a1.85,1.85,0,0,1,.28,1.23.79.79,0,0,1-.47.52,2.62,2.62,0,0,1-.54.13A8.58,8.58,0,0,1,345.57,138.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M347.89,153.6a23.19,23.19,0,0,1-12.45-2s3.55,5.93,12.54,4.19Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M345.34,142a2.27,2.27,0,0,0-2.1-.64,2.1,2.1,0,0,0-1.35.91,1.31,1.31,0,0,0,.05,1.5,1.52,1.52,0,0,0,1.68.25,4.76,4.76,0,0,0,1.5-1.11,1.27,1.27,0,0,0,.32-.41.42.42,0,0,0,0-.46",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342,140.11c.2,0,.33,1.33,1.59,2.18s2.69.56,2.72.74-.3.3-.91.38a3.39,3.39,0,0,1-2.26-.55,2.94,2.94,0,0,1-1.25-1.83C341.76,140.47,341.88,140.11,342,140.11Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.48,127c.08.19.94,0,2,0s1.91.15,2,0-.79-.69-2-.68S348.4,126.8,348.48,127Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.89,127.51s0-.1,0-.21l0,.18a8.71,8.71,0,0,1,2-.48c1.19-.13,2.13.26,2.23.08s-.15-.3-.55-.5a3.32,3.32,0,0,0-1.74-.3,2.92,2.92,0,0,0-2,1l-.09.15.06,0C335.78,127.52,335.85,127.54,335.89,127.51Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M335.57,135.66c.1,0,.2-.12.22-.3s0-.34-.14-.35-.2.12-.22.3S335.47,135.65,335.57,135.66Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M338.44,135.54c.1,0,.17-.17.09-.34s-.23-.24-.31-.18a.35.35,0,0,0,.22.52Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M336.89,136.77c.1,0,.17-.11.16-.23a.2.2,0,0,0-.19-.21.2.2,0,0,0-.16.23A.19.19,0,0,0,336.89,136.77Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M353.26,135c.09,0,.16-.17.13-.35s-.12-.32-.21-.3-.17.16-.14.34S353.16,135,353.26,135Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M350.37,135c.1,0,.17-.12.16-.27s-.09-.26-.19-.26-.18.13-.17.28S350.27,135,350.37,135Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M351.78,136c.1,0,.18-.15.18-.33s-.08-.32-.18-.32-.18.14-.18.32S351.68,136,351.78,136Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.8,110.53a11.31,11.31,0,0,1-9.53,14.22,4,4,0,0,0-2.19.63,4.25,4.25,0,0,0-1,2.33,8.83,8.83,0,0,1-4.31,5.63c2.75,5.14,3.25,14-.67,16.73-9.8-5-5.32-13.08-6.95-18.52-1.91-6.39.48-12.9,5.27-17.53s13-5.62,19.34-3.49",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323,125.89a10.8,10.8,0,0,0,2.21-6.16,7.83,7.83,0,0,0-2.51-5.94,8,8,0,0,0-4.31-1.82,9.78,9.78,0,0,0-9.07,4,9.27,9.27,0,0,0-.38,9.85,8.81,8.81,0,0,0,8.91,4,8.38,8.38,0,0,0,6.64-7.11",
    transform: "translate(-35.35 -52.14)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.08,458l-2,8.31s-13.58,17.64-17.77,16.77c-2.74-.56.63-5.16,5.79-18.56l1.09-5.54Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.78,480.45a1.68,1.68,0,0,0,.72.69,2.51,2.51,0,0,0,2.6-.36,75,75,0,0,0,6.76-6.4c2.52-2.64,4.63-5.18,6.11-7.05.67-.85,1.24-1.6,1.74-2.24.17-.21.32-.41.47-.61a1.52,1.52,0,0,1,.18-.2,1.08,1.08,0,0,1-.14.23l-.43.64c-.39.55-1,1.33-1.68,2.29a86.66,86.66,0,0,1-6.07,7.1,67.05,67.05,0,0,1-6.84,6.39,3.15,3.15,0,0,1-1.54.56,2.27,2.27,0,0,1-1.2-.26,1.48,1.48,0,0,1-.57-.53A.69.69,0,0,1,168.78,480.45Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.7,474.78a2.21,2.21,0,0,1,1.12-.13,6,6,0,0,1,2.56.89,4.76,4.76,0,0,1,1.86,2,2.31,2.31,0,0,1,.29,1.08s-.13-.41-.45-1a4.91,4.91,0,0,0-1.83-1.84,6.4,6.4,0,0,0-2.45-.92A10.75,10.75,0,0,0,170.7,474.78Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.56,470.64a1.21,1.21,0,0,1-.16-.4,6.2,6.2,0,0,1-.27-1.14,6.14,6.14,0,0,1,.63-3.77,5.77,5.77,0,0,1,2.75-2.67,4.44,4.44,0,0,1,1.12-.35,1,1,0,0,1,.43,0,8.52,8.52,0,0,0-1.48.52,6,6,0,0,0-2.6,2.63,6.4,6.4,0,0,0-.68,3.64C183.41,470,183.6,470.63,183.56,470.64Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.21,459.38c.06,0-.24,1.18-.5,2.65a8.86,8.86,0,0,1-.71,2.61c-.05,0,.22-1.18.47-2.66A9.43,9.43,0,0,1,188.21,459.38Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.88,465.66a3.21,3.21,0,0,1,1.75,0,3.16,3.16,0,0,1,1.57.74c0,.07-.72-.3-1.63-.5S174.89,465.73,174.88,465.66Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.61,467.08a2.76,2.76,0,0,1,2.75.66c0,.06-.58-.3-1.34-.47S174.62,467.15,174.61,467.08Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.52,468.87a2.23,2.23,0,0,1,2.81.63,6.9,6.9,0,0,0-1.34-.59A6.17,6.17,0,0,0,173.52,468.87Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.82,465.06s.63-.17,1.59-.54a12,12,0,0,0,1.64-.79,9.1,9.1,0,0,0,.9-.58c.28-.2.59-.5.57-.82s-.41-.5-.72-.42a1.86,1.86,0,0,0-.84.56c-.5.47-.93.92-1.27,1.31-.7.77-1.08,1.29-1.11,1.27s.06-.15.23-.39a10.64,10.64,0,0,1,.75-1,16,16,0,0,1,1.25-1.35,2.1,2.1,0,0,1,.94-.64.79.79,0,0,1,1,.64,1.37,1.37,0,0,1-.68,1,9.44,9.44,0,0,1-.93.58,10.26,10.26,0,0,1-1.69.75,9.57,9.57,0,0,1-1.2.33A1.11,1.11,0,0,1,175.82,465.06Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.53,464.89s-.09-.58-.25-1.52a6.17,6.17,0,0,0-.46-1.57,3.28,3.28,0,0,0-.51-.8c-.2-.23-.52-.43-.77-.28s-.29.52-.25.82a3.48,3.48,0,0,0,.26.92,5.09,5.09,0,0,0,.89,1.36c.63.7,1.12,1,1.09,1.07a1.1,1.1,0,0,1-.36-.21,6.29,6.29,0,0,1-.86-.74,5.14,5.14,0,0,1-1-1.39,4.15,4.15,0,0,1-.29-1,1,1,0,0,1,.37-1.07.89.89,0,0,1,1.07.34,3.89,3.89,0,0,1,.54.87,5.74,5.74,0,0,1,.42,1.64,9.58,9.58,0,0,1,.09,1.13A1.21,1.21,0,0,1,176.53,464.89Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.1,466.28l1-4s-3.33.61-4.19,3.1a10.35,10.35,0,0,0-.65,4.27L176,477.45s-1.81-3.55-5.1-2.7c0,0-2.58,5.69-2.5,7.11s1.73,1.26,2.32,1a29.19,29.19,0,0,0,6.48-5.11C181,473.76,185.24,468.72,187.1,466.28Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.15,461.83l.06-11.08-20.74-.25-.26,16.2,1.28.1c5.72.39,29.11,1.57,32.95.45C271.73,466,254.15,461.83,254.15,461.83Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.73,466.63a7.17,7.17,0,0,0-2.6-4.45,7,7,0,0,0-4.83-1.57l-.07,5.8Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.73,464.18s6.16,1.85,5.38,2.86-24.47.71-34.9-.34l0-.46,27.63.59S261.53,464.21,262.73,464.18Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.92,466.22a1.41,1.41,0,0,0,.35,0l1,.07,3.77.21c3.18.16,7.58.31,12.44.38s9.27,0,12.45,0l3.78-.11,1,0a1.65,1.65,0,0,0,.36,0,1.48,1.48,0,0,0-.36,0h-1l-3.77,0c-3.18,0-7.58,0-12.45,0s-9.25-.2-12.44-.31l-3.77-.13-1,0A1.63,1.63,0,0,0,232.92,466.22Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M260.86,467.15a7.82,7.82,0,0,1,.72-1.79,9,9,0,0,1,1.31-1.43,2.81,2.81,0,0,0-1.52,1.29A2.73,2.73,0,0,0,260.86,467.15Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.78,464c.05,0,.35-.32.66-.79s.51-.89.45-.93-.35.32-.66.79S254.72,463.93,254.78,464Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.11,463.06c0,.05.37-.17.74-.48s.61-.62.57-.67-.38.16-.74.48S253.06,463,253.11,463.06Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.07,461.08a2.46,2.46,0,0,0,1.08.16,2.52,2.52,0,0,0,1.09-.1,2.46,2.46,0,0,0-1.08-.16A2.52,2.52,0,0,0,252.07,461.08Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.72,459.7a2.13,2.13,0,0,0,1.21.37,2.21,2.21,0,0,0,1.25-.15,5.83,5.83,0,0,0-1.23-.1A6.41,6.41,0,0,0,251.72,459.7Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.5,462.16a3.76,3.76,0,0,0,1.34,0,7.46,7.46,0,0,0,1.42-.29,4.13,4.13,0,0,0,.82-.33.67.67,0,0,0,.33-.41.53.53,0,0,0-.19-.53,2.44,2.44,0,0,0-3,.68,2.39,2.39,0,0,0-.44.88c-.06.23-.06.36,0,.36a3.49,3.49,0,0,1,.62-1.13,2.46,2.46,0,0,1,1.15-.73,2.1,2.1,0,0,1,1.59.13c.2.16.12.41-.12.55a3.82,3.82,0,0,1-.75.31,11,11,0,0,1-1.38.34C256,462.13,255.5,462.12,255.5,462.16Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.85,462.24a1.33,1.33,0,0,0,.16-.93,2.24,2.24,0,0,0-.35-1,1.32,1.32,0,0,0-1.1-.69.54.54,0,0,0-.42.61,1.39,1.39,0,0,0,.22.6,3.66,3.66,0,0,0,.62.81c.41.42.74.58.76.55s-.27-.24-.63-.67a5,5,0,0,1-.55-.8c-.18-.29-.3-.8,0-.85s.67.31.87.57a2.25,2.25,0,0,1,.37.88A6.42,6.42,0,0,1,255.85,462.24Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.41,460.55c0,.05.6-.05,1.54.08a6.49,6.49,0,0,1,5.37,4.4c.31.89.33,1.49.38,1.48a1.51,1.51,0,0,0,0-.42,4.68,4.68,0,0,0-.21-1.12,6.29,6.29,0,0,0-5.53-4.52,5.93,5.93,0,0,0-1.14,0A1.75,1.75,0,0,0,233.41,460.55Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.67,452a36.66,36.66,0,0,0-.23,4.26,35.59,35.59,0,0,0,0,4.26,36.66,36.66,0,0,0,.23-4.26A35.59,35.59,0,0,0,235.67,452Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.36,464.64a11.25,11.25,0,0,0,3,.34,12.29,12.29,0,0,0,3-.2c0-.08-1.37,0-3,0S243.37,464.57,243.36,464.64Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.3,464.58c-.05.05.11.29.24.6s.21.59.28.59.11-.33,0-.69S239.34,464.53,239.3,464.58Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.79,462.66s.08.26.29.48.43.36.48.32-.08-.27-.29-.49S237.84,462.61,237.79,462.66Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.61,461.76c0,.07.29.07.59.18s.52.28.58.23-.12-.33-.49-.47S235.59,461.69,235.61,461.76Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.05,461.33c0,.06.1.17.27.24s.33.07.35,0-.09-.18-.26-.24S234.08,461.26,234.05,461.33Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "229.26 200.32 220.67 406.97 195.38 406.54 197.9 226.03 157.38 407.54 135.35 407.54 170.42 198.01 229.26 200.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.69,257.3a20.32,20.32,0,0,1-.37,3.42c-.3,2.11-.76,5-1.29,8.21a33.85,33.85,0,0,1-.93,4.51,6.33,6.33,0,0,1-2.11,3.18,4.93,4.93,0,0,1-2.34,1,2,2,0,0,1-.94,0,6.27,6.27,0,0,0,3-1.35,6.16,6.16,0,0,0,1.86-3,39,39,0,0,0,.87-4.45c.53-3.2,1.05-6.09,1.45-8.17A22.25,22.25,0,0,1,240.69,257.3Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234,258.29c.07,0-.19.39,0,.94a1.06,1.06,0,0,0,.54.69.89.89,0,0,0,1-.19.9.9,0,0,0,.32-.93,1.08,1.08,0,0,0-.62-.62c-.53-.23-.89,0-.93-.08s.29-.48,1.05-.31a1.44,1.44,0,0,1,1,.83,1.46,1.46,0,0,1-2,1.77,1.49,1.49,0,0,1-.7-1.09C233.46,258.53,234,258.22,234,258.29Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.62,261.26a4.49,4.49,0,0,1-.42-3,4.43,4.43,0,0,1,1-2.81c.15.07-.32,1.29-.48,2.87S216.79,261.22,216.62,261.26Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.51,261a7,7,0,0,1,.42-6,28.42,28.42,0,0,1-.32,3A27.36,27.36,0,0,1,220.51,261Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.89,261.86a19.75,19.75,0,0,1,.19-3.12,17.76,17.76,0,0,1,.14-3.13,6.07,6.07,0,0,1,.43,3.16A5.85,5.85,0,0,1,253.89,261.86Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.11,261.62c-.15-.06.35-1.42.46-3.17s-.18-3.15,0-3.2a5.11,5.11,0,0,1,.58,3.24A5,5,0,0,1,258.11,261.62Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M223.14,163.24l19.94-1.59c.13-2.33,0-11.34,0-11.34s8.3-1.29,8.4-9.59-1.34-27.34-1.34-27.34h0a28.81,28.81,0,0,0-29,3.64l-1.23.94Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M243.05,150.19a19.25,19.25,0,0,1-10.81-3.07s2.55,6,10.83,5.22Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M220.92,126.56c-.14-.06-5.7-1.69-5.52,4s5.84,4.32,5.85,4.16S220.92,126.56,220.92,126.56Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M219.45,132.61s-.1.07-.26.15a1,1,0,0,1-.74,0,2.44,2.44,0,0,1-1.2-2.16,3.13,3.13,0,0,1,.23-1.42,1.13,1.13,0,0,1,.72-.78.5.5,0,0,1,.59.25c.08.16.05.27.08.28s.12-.1.06-.33a.61.61,0,0,0-.23-.35.73.73,0,0,0-.55-.13,1.41,1.41,0,0,0-1,.91,3.47,3.47,0,0,0-.29,1.6,2.55,2.55,0,0,0,1.52,2.4,1.07,1.07,0,0,0,.9-.18C219.44,132.74,219.47,132.62,219.45,132.61Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.28,126.38a1.18,1.18,0,0,1-1.15,1.19,1.13,1.13,0,0,1-1.22-1.06,1.18,1.18,0,0,1,1.14-1.2A1.14,1.14,0,0,1,248.28,126.38Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.53,125.05c-.14.15-1-.51-2.32-.51s-2.2.64-2.34.49.08-.35.49-.65a3.3,3.3,0,0,1,1.88-.58,3.14,3.14,0,0,1,1.84.6C248.47,124.7,248.61,125,248.53,125.05Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.79,126.68a1.18,1.18,0,0,1-1.14,1.19,1.13,1.13,0,0,1-1.22-1.06,1.18,1.18,0,0,1,1.14-1.2A1.13,1.13,0,0,1,235.79,126.68Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236,125.28c-.15.16-1-.51-2.32-.5s-2.21.64-2.35.48.08-.34.49-.64a3.25,3.25,0,0,1,1.88-.58,3.08,3.08,0,0,1,1.85.6C235.94,124.94,236.07,125.22,236,125.28Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.63,134.74a8.45,8.45,0,0,1,2.07-.37c.33,0,.63-.1.69-.32a1.71,1.71,0,0,0-.22-1c-.31-.79-.63-1.61-1-2.48a41.24,41.24,0,0,1-2.16-6.48,42.05,42.05,0,0,1,2.67,6.29c.33.87.63,1.7.93,2.5a1.93,1.93,0,0,1,.17,1.27.83.83,0,0,1-.54.48,2.43,2.43,0,0,1-.55.08A8.31,8.31,0,0,1,240.63,134.74Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.88,135.62c.2,0,.21,1.37,1.39,2.36s2.66.83,2.67,1-.33.27-.95.28a3.41,3.41,0,0,1-2.23-.77,3,3,0,0,1-1.08-2C236.63,136,236.78,135.61,236.88,135.62Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.33,120.29c-.12.34-1.4.18-2.89.36s-2.71.59-2.91.28c-.09-.15.12-.48.61-.81a4.84,4.84,0,0,1,2.15-.76,5,5,0,0,1,2.27.27C236.11,119.85,236.39,120.12,236.33,120.29Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.07,121.36c-.23.29-1.11,0-2.16,0s-1.95.2-2.16-.11c-.09-.14.05-.43.44-.71A3,3,0,0,1,246,120a3,3,0,0,1,1.72.58C248,120.92,248.16,121.22,248.07,121.36Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.8,123.31a5.2,5.2,0,0,1-3.69-6.24,7.45,7.45,0,0,1,6.18-12.44,8.12,8.12,0,0,1,14.39-5A6.67,6.67,0,0,1,248,105.86a3.62,3.62,0,0,1,4.85,5.37,2.65,2.65,0,0,1,.12,5.17,3.51,3.51,0,0,1-6.71,1.1c-.44,2-2.95,3-4.86,2.3a6.88,6.88,0,0,1-3.88-4.4,3.52,3.52,0,0,1-6,.07,3.43,3.43,0,0,1-2.67,4.4,4.89,4.89,0,0,1-9.76-.61",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.32,119.46c.26,2.25,1,6.78,1.34,9a2.69,2.69,0,0,0,.74,1.75,1.85,1.85,0,0,0,2.5-.54,5.43,5.43,0,0,0,.81-2.69c.26-2.3.53-4.59.79-6.89",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239.2,126.3s0-.5-.27-1.33a5.47,5.47,0,0,0-2-2.92,5.3,5.3,0,1,0,0,8.49,5.47,5.47,0,0,0,2-2.92c.23-.83.22-1.33.27-1.32s0,.12,0,.35a3.91,3.91,0,0,1-.11,1,5.51,5.51,0,0,1-2,3.17,5.71,5.71,0,0,1-8.12-1.12,5.74,5.74,0,0,1,0-6.84,5.63,5.63,0,0,1,2.69-2,5.72,5.72,0,0,1,5.43.87,5.51,5.51,0,0,1,2,3.17,4,4,0,0,1,.11,1C239.23,126.17,239.22,126.3,239.2,126.3Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M253.48,126.3s0-.5-.27-1.33a5.47,5.47,0,0,0-2-2.92,5.3,5.3,0,1,0,0,8.49,5.47,5.47,0,0,0,2-2.92c.23-.83.22-1.33.27-1.32s0,.12,0,.35a3.91,3.91,0,0,1-.11,1,5.51,5.51,0,0,1-2,3.17,5.71,5.71,0,0,1-8.12-1.12,5.74,5.74,0,0,1,0-6.84,5.63,5.63,0,0,1,2.69-2,5.72,5.72,0,0,1,5.43.87,5.51,5.51,0,0,1,2,3.17,4,4,0,0,1,.11,1C253.51,126.17,253.5,126.3,253.48,126.3Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.4,125.71c0,.15-.73.26-1.62.26s-1.62-.11-1.62-.26.72-.26,1.62-.26S242.4,125.57,242.4,125.71Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.74,125.45a38,38,0,0,1-8.85.94,18.68,18.68,0,0,1,4.4-.73A19.35,19.35,0,0,1,228.74,125.45Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M231.61,103.53a1,1,0,0,1,.43.17,2,2,0,0,1,.79,1.08,2.46,2.46,0,0,1-.24,2.09,2.54,2.54,0,0,1-2.58,1,3,3,0,0,1-2.49-2.24,4.18,4.18,0,0,1,.85-3.78c1.84-2.21,5.42-2.8,8.34-1.51a6.51,6.51,0,0,1,3.26,2.92,3.81,3.81,0,0,1-.26,4l-.29-.37a4.92,4.92,0,0,1,5.53,1,4.14,4.14,0,0,1,.87,4.34,3.78,3.78,0,0,1-2.09,2.05,2.81,2.81,0,0,1-.77.19,1.1,1.1,0,0,1-.27,0,9.26,9.26,0,0,0,1-.33,3.72,3.72,0,0,0,1.88-2,3.84,3.84,0,0,0-.9-4,4.53,4.53,0,0,0-5-.87l-.88.39.6-.76a3.36,3.36,0,0,0,.19-3.52,6.14,6.14,0,0,0-3-2.67c-2.73-1.22-6.09-.65-7.76,1.33a3.77,3.77,0,0,0-.81,3.36,2.68,2.68,0,0,0,2.14,2,2.25,2.25,0,0,0,2.28-.8,2.31,2.31,0,0,0,.29-1.87,2,2,0,0,0-.66-1C231.76,103.6,231.6,103.56,231.61,103.53Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M266.6,168.4s7.33,7.62,7.48,28.09c.1,14.78,1.44,32.67,1.44,32.67l-10.13-.82,1.21-59.94",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M196.64,174.14c1.76-5.93,8.1-12.34,16.9-14,2.8-.54,5.52-1.55,8.81-1.69h0a35.3,35.3,0,0,0,21.26,0c.87.11,2.06.22,3.57.4,9.24,1.09,12.78,3,19.42,9.56l-.73,37.39s-.32,42.33-.48,49.2l-60.58.22,3.47-39.81",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.28,215.4l-11.64,15.15,4.43,4.51-12.29,16.06S166.94,238,167.54,234.36s29.85-62.18,29.85-62.18,11.79,1.23,10.89,18.45S208.28,215.4,208.28,215.4Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.93,221.39a5.47,5.47,0,0,1-.21-1.23c-.09-.8-.22-1.95-.36-3.38-.28-2.85-.62-6.8-.88-11.17s-.33-8.33-.29-11.2c0-1.44.06-2.6.11-3.4a6,6,0,0,1,.12-1.24,5.61,5.61,0,0,1,.08,1.25c0,.9,0,2,.06,3.39.06,2.86.19,6.81.44,11.17s.54,8.2.73,11.17c.08,1.35.14,2.48.2,3.39A6.7,6.7,0,0,1,208.93,221.39Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184,235.51a5.57,5.57,0,0,1,1.36-1.62,15.31,15.31,0,0,1,4.28-2.84,11,11,0,0,1,5-1.13,2.69,2.69,0,0,1,2,.8,6.27,6.27,0,0,0-2-.44,12.5,12.5,0,0,0-4.78,1.25A24.92,24.92,0,0,0,184,235.51Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M186.49,225.53a12,12,0,0,1,6,.9,15.07,15.07,0,0,1,2.17,1,6.13,6.13,0,0,1,1.62,1.14,1.47,1.47,0,0,1,.36,1.33c-.1.33-.28.43-.3.4s.08-.16.1-.44a1.33,1.33,0,0,0-.43-1,7.21,7.21,0,0,0-1.58-1,19.23,19.23,0,0,0-2.12-.93A36.66,36.66,0,0,0,186.49,225.53Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.55,237.24c-.15,0-.3-12.13-.34-27.08s0-27.08.18-27.08.29,12.12.34,27.08S265.69,237.24,265.55,237.24Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.76,216.07c-2.12-4.49-3.79-8.94-5.48-13.62-.16-.44-.29-1,.05-1.34a.85.85,0,0,1,1.07,0,2.5,2.5,0,0,1,.64,1,29.79,29.79,0,0,1,1.33-8.89c.14-.47.44-1,.92-1s.66.72.68,1.23c.27,7.56,1,14.37,1.31,21.93",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.71,230.37a1.88,1.88,0,0,0-.91-1.22,4.52,4.52,0,0,0-1.49-.5,14.05,14.05,0,0,0-11.56,2.51,3.74,3.74,0,0,0-1.24,1.55,1.62,1.62,0,0,0,.44,1.82,1.72,1.72,0,0,0,1.5.17,6.09,6.09,0,0,0,1.37-.75,26.61,26.61,0,0,1,5.54-2.78,11.53,11.53,0,0,1,6.31-.74",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.78,206.24s-.14.19-.49.42a3,3,0,0,1-.68.36,1.77,1.77,0,0,1-.5.1.75.75,0,0,1-.58-.26,21.77,21.77,0,0,1-2.94-4.93,41,41,0,0,1-2-5.36,10.16,10.16,0,0,1-.57-2.29,10.59,10.59,0,0,1,.92,2.18c.51,1.36,1.19,3.24,2.12,5.25a27.75,27.75,0,0,0,2.74,4.89c.16.26.46.2.73.14a5,5,0,0,0,.67-.25C207.56,206.32,207.76,206.21,207.78,206.24Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.41,249.84a.56.56,0,0,1,0-.23c0-.18,0-.41-.06-.68,0-.65-.09-1.53-.15-2.64-.12-2.29-.27-5.6-.41-9.7-.3-8.2-.58-19.52-.62-32s.25-23.85.71-32c.26-4.09.47-7.4.73-9.68.11-1.11.2-2,.27-2.63,0-.27.06-.5.08-.68s0-.23.05-.23a.82.82,0,0,1,0,.23c0,.19,0,.41,0,.69,0,.65-.1,1.52-.17,2.63-.19,2.29-.34,5.6-.56,9.69-.37,8.19-.6,19.51-.55,32s.25,23.82.46,32c.1,4.06.18,7.36.24,9.7,0,1.11,0,2,.06,2.64v.69A2.07,2.07,0,0,1,216.41,249.84Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.94,160a.92.92,0,0,1,0,.24c0,.19,0,.43.07.72,0,.67.12,1.6.21,2.76.18,2.41.39,5.88.62,10.18.45,8.6.88,20.5.92,33.64s-.35,25-.83,33.64c-.24,4.3-.47,7.78-.68,10.18-.1,1.16-.17,2.09-.23,2.76,0,.29-.06.52-.08.72a.92.92,0,0,1,0,.24.93.93,0,0,1,0-.25c0-.19,0-.43,0-.72,0-.67.08-1.6.14-2.77.14-2.4.32-5.88.51-10.18.38-8.6.71-20.48.68-33.62s-.41-25-.77-33.62c-.19-4.26-.34-7.73-.45-10.18-.05-1.17-.09-2.1-.12-2.77,0-.29,0-.53,0-.72A.93.93,0,0,1,234.94,160Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.63,255.53a.87.87,0,0,1,0-.25c0-.19,0-.42,0-.71,0-.66-.08-1.58-.14-2.73-.12-2.38-.23-5.82-.31-10.07-.16-8.5-.09-20.26.55-33.22s1.74-24.67,2.74-33.12c.5-4.22.95-7.63,1.3-10,.17-1.15.31-2,.41-2.71l.12-.7a.81.81,0,0,1,.06-.24,1.08,1.08,0,0,1,0,.24c0,.19,0,.43-.07.71-.07.67-.18,1.57-.31,2.72-.29,2.36-.68,5.78-1.13,10-.91,8.45-1.95,20.15-2.59,33.11s-.76,24.69-.7,33.19c0,4.25.09,7.69.14,10.06,0,1.16,0,2.07,0,2.74v.71A.72.72,0,0,1,253.63,255.53Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176,241.65a4,4,0,0,1-.47-.67,7.59,7.59,0,0,1-.85-2.19c-.5-2-.17-5.08,1.15-8.48.63-1.71,1.49-3.51,2.37-5.44l2.8-6.21c1.94-4.38,4-9.22,6.12-14.33,4.21-10.24,7.67-19.64,10.09-26.47l2.82-8.11.77-2.21a5.19,5.19,0,0,1,.3-.75,4.46,4.46,0,0,1-.2.79c-.17.55-.39,1.3-.68,2.23-.6,1.94-1.5,4.73-2.66,8.17-2.33,6.87-5.75,16.3-10,26.54-2.1,5.13-4.19,10-6.16,14.34-1,2.19-1.94,4.26-2.85,6.19s-1.77,3.71-2.42,5.4c-1.34,3.34-1.72,6.33-1.29,8.29A9.62,9.62,0,0,0,176,241.65Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.78,227c-.12-.07,2.49-5.58,5.84-12.31s6.17-12.15,6.3-12.08-2.48,5.57-5.83,12.31S190.91,227.05,190.78,227Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.85,242.23a12.06,12.06,0,0,1-4-4,12.23,12.23,0,0,1-2.2-5.26,51.42,51.42,0,0,0,2.63,5A48.74,48.74,0,0,0,193.85,242.23Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218,235.53a94.22,94.22,0,0,0,49.24-.54Z",
    transform: "translate(-35.35 -52.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M218.85,252s9.28,12.15,9.84,14.18c.35,1.25-.48,1.8-1.56,1.08s-7.52-7.43-7.52-7.43-1.39-.63-.76.34,5.3,9,5.7,10.27c.9,2.92-1.28,4.07-2.44,2.6a15.07,15.07,0,0,1-1-1.32,3.76,3.76,0,0,1-.25,2,1.38,1.38,0,0,1-2,.12c-.58-.84-3.44-5.35-3.56-5.71a8.14,8.14,0,0,0-.69-1.2,39.3,39.3,0,0,1,.63,5.11c-.11.84-1.58.57-2.3-.75s-3.1-6.58-3.1-6.58-7.45-6.73-8.18-8.29a26.2,26.2,0,0,1-1.2-3.25l-9.37-5L198.83,238s17,10.6,20.14,14.11",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M216.4,262.15a31.67,31.67,0,0,1,4.91,9.52,43.57,43.57,0,0,1-2.51-4.73A45.16,45.16,0,0,1,216.4,262.15Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M212.26,261.7a6.19,6.19,0,0,1,1.89,2.77,6.36,6.36,0,0,1,.67,3.29c-.16,0-.45-1.43-1.15-3.09S212.14,261.79,212.26,261.7Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M289.75,234.3s.33,3.66-.38,4.65-5.4,1-7.51,1H265.58l-.07-5.83Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.06,198.41C299.53,208.47,286.84,235,286.84,235H218.05a3.2,3.2,0,0,1,3.2-3.2h12.61l14.69-35.51a2.69,2.69,0,0,1,2.49-1.66H301.6A2.69,2.69,0,0,1,304.06,198.41Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M273.62,215.07a3,3,0,0,0-2.39-1,3,3,0,0,0-2.76,2.57,2.61,2.61,0,0,0,2.28,2.67,3.05,3.05,0,0,0,3.06-1.91A2.48,2.48,0,0,0,273.62,215.07Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M286.38,236.65a34.84,34.84,0,0,0-.32-9.46,3.11,3.11,0,0,0-.44-1.14,1.34,1.34,0,0,0-1-.63,1.4,1.4,0,0,0-1.24.77,3.86,3.86,0,0,0-.39,1.47c-.29,2.2-.53,7.15-.53,9.36",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M282.46,236.15a22.55,22.55,0,0,0,0-7.6,3.3,3.3,0,0,0-.44-1.14,1.34,1.34,0,0,0-1-.63,1.41,1.41,0,0,0-1.24.77,4.06,4.06,0,0,0-.4,1.47,52.58,52.58,0,0,0-.42,6.63",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M278.89,238.53a22.55,22.55,0,0,0,0-7.6,3.28,3.28,0,0,0-.43-1.14,1.39,1.39,0,0,0-1-.63,1.41,1.41,0,0,0-1.24.77,4,4,0,0,0-.4,1.48,52.34,52.34,0,0,0-.42,6.63",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M289.63,237.71a20.85,20.85,0,0,0-.17-5.87,3.16,3.16,0,0,0-.43-1.13,1.4,1.4,0,0,0-1-.64,1.41,1.41,0,0,0-1.24.77,4,4,0,0,0-.4,1.48A52.46,52.46,0,0,0,286,239",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M278.15,238.18c0-.07.47,0,.82-.55s.24-1.42.19-2.47a13.54,13.54,0,0,1,.08-3.78,14,14,0,0,1,.44,3.76c0,.52.06,1,0,1.49a2,2,0,0,1-.45,1.23,1.15,1.15,0,0,1-.79.41C278.25,238.28,278.15,238.21,278.15,238.18Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M282.33,238.61a1.3,1.3,0,0,0,.56-1,7.2,7.2,0,0,0-.05-1.35c0-.57-.09-1.13-.13-1.72a19.28,19.28,0,0,1,0-4.44,19.32,19.32,0,0,1,.53,4.41c0,.59.06,1.15.08,1.72a5.25,5.25,0,0,1-.06,1.45,1.29,1.29,0,0,1-.54.87C282.48,238.67,282.34,238.63,282.33,238.61Z",
    transform: "translate(-35.35 -52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M287.09,237.65a14.4,14.4,0,0,1-.57-6.6,40.59,40.59,0,0,1,.57,6.6Z",
    transform: "translate(-35.35 -52.14)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.76e3825ebf4be61bdf05a5d0af6f9b16.svg";
export { ForwardRef as ReactComponent };